export const SITE_URL = 'https://coeater.com'

const BLOGS_API_BASE =
  (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_API_URL) ||
  (typeof process !== 'undefined' && process.env && process.env.VITE_API_URL) ||
  'http://localhost:9000'

export function slugifySeoSegment(value) {
  return String(value || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/['’]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

export function titleCaseFromSlug(value) {
  return String(value || '')
    .replace(/-/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .split(' ')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export function getRestaurantSeoPath(cityName, restaurantName) {
  const citySegment = slugifySeoSegment(cityName)
  const restaurantSegment = slugifySeoSegment(restaurantName)
  return restaurantSegment ? `/restaurants/${citySegment}/${restaurantSegment}` : `/restaurants/${citySegment}`
}

export function getRestaurantCitySeoPath(cityName) {
  return `/restaurants/${slugifySeoSegment(cityName)}`
}

export function getProfileSeoPath(name) {
  return `/profile/${slugifySeoSegment(name)}`
}

export function getEventSeoPath(cityName, eventName) {
  return `/events/${slugifySeoSegment(cityName)}/${slugifySeoSegment(eventName)}`
}

export function getEventCitySeoPath(cityName) {
  return `/events/${slugifySeoSegment(cityName)}`
}

export const MAJOR_INDIAN_CITIES = [
  { name: 'Mumbai', slug: 'mumbai' },
  { name: 'Delhi', slug: 'delhi' },
  { name: 'Bengaluru', slug: 'bengaluru' },
  { name: 'Hyderabad', slug: 'hyderabad' },
  { name: 'Chennai', slug: 'chennai' },
  { name: 'Kolkata', slug: 'kolkata' },
  { name: 'Pune', slug: 'pune' },
  { name: 'Ahmedabad', slug: 'ahmedabad' },
  { name: 'Jaipur', slug: 'jaipur' },
  { name: 'Surat', slug: 'surat' },
  { name: 'Lucknow', slug: 'lucknow' },
  { name: 'Kanpur', slug: 'kanpur' },
  { name: 'Nagpur', slug: 'nagpur' },
  { name: 'Indore', slug: 'indore' },
  { name: 'Bhopal', slug: 'bhopal' },
  { name: 'Patna', slug: 'patna' },
  { name: 'Visakhapatnam', slug: 'visakhapatnam' },
  { name: 'Coimbatore', slug: 'coimbatore' },
  { name: 'Kochi', slug: 'kochi' },
  { name: 'Chandigarh', slug: 'chandigarh' },
  { name: 'Noida', slug: 'noida' },
  { name: 'Gurugram', slug: 'gurugram' },
  { name: 'Thane', slug: 'thane' },
  { name: 'Bhubaneswar', slug: 'bhubaneswar' },
  { name: 'Guwahati', slug: 'guwahati' },
  { name: 'Shanghai', slug: 'shanghai' },
  { name: 'Istanbul', slug: 'istanbul' },
  { name: 'Buenos Aires', slug: 'buenos-aires' },
  { name: 'Mexico City', slug: 'mexico-city' },
  { name: 'Beijing', slug: 'beijing' },
  { name: 'Karachi', slug: 'karachi' },
  { name: 'Tianjin', slug: 'tianjin' },
  { name: 'Guangzhou', slug: 'guangzhou' },
  { name: 'Moscow', slug: 'moscow' },
  { name: 'Shenzhen', slug: 'shenzhen' },
  { name: 'Dhaka', slug: 'dhaka' },
  { name: 'Seoul', slug: 'seoul' },
  { name: 'São Paulo', slug: 'sao-paulo' },
  { name: 'Wuhan', slug: 'wuhan' },
  { name: 'Lagos', slug: 'lagos' },
  { name: 'Jakarta', slug: 'jakarta' },
  { name: 'Tokyo', slug: 'tokyo' },
  { name: 'New York City', slug: 'new-york-city' },
  { name: 'Dongguan', slug: 'dongguan' },
  { name: 'Taipei', slug: 'taipei' },
  { name: 'Kinshasa', slug: 'kinshasa' },
  { name: 'Lima', slug: 'lima' },
  { name: 'Cairo', slug: 'cairo' },
  { name: 'Bogotá', slug: 'bogota' },
  { name: 'London', slug: 'london' },
  { name: 'Chongqing', slug: 'chongqing' },
  { name: 'Chengdu', slug: 'chengdu' },
  { name: 'Baghdad', slug: 'baghdad' },
  { name: 'Nanjing', slug: 'nanjing' },
  { name: 'Tehran', slug: 'tehran' },
  { name: 'Nanchong', slug: 'nanchong' },
  { name: 'Hong Kong', slug: 'hong-kong' },
  { name: 'Xi’an', slug: 'xian' },
  { name: 'Lahore', slug: 'lahore' },
  { name: 'Shenyang', slug: 'shenyang' },
  { name: 'Hangzhou', slug: 'hangzhou' },
  { name: 'Rio de Janeiro', slug: 'rio-de-janeiro' },
  { name: 'Harbin', slug: 'harbin' },
  { name: 'Tai’an', slug: 'taian' },
  { name: 'Suzhou', slug: 'suzhou' },
  { name: 'Shantou', slug: 'shantou' },
  { name: 'Bangkok', slug: 'bangkok' },
  { name: 'Saint Petersburg', slug: 'saint-petersburg' },
  { name: 'Santiago', slug: 'santiago' },
  { name: 'Sydney', slug: 'sydney' },
  { name: 'Yangon', slug: 'yangon' },
  { name: 'Jinan', slug: 'jinan' },
  { name: 'Zhengzhou', slug: 'zhengzhou' },
  { name: 'Melbourne', slug: 'melbourne' },
  { name: 'Riyadh', slug: 'riyadh' },
  { name: 'Changchun', slug: 'changchun' },
  { name: 'Dalian', slug: 'dalian' },
  { name: 'Los Angeles', slug: 'los-angeles' },
  { name: 'Chittagong', slug: 'chittagong' },
  { name: 'Kunming', slug: 'kunming' },
  { name: 'Alexandria', slug: 'alexandria' },
  { name: 'Qingdao', slug: 'qingdao' },
  { name: 'Busan', slug: 'busan' },
  { name: 'Abidjan', slug: 'abidjan' },
  { name: 'Kano', slug: 'kano' },
  { name: 'Foshan', slug: 'foshan' },
  { name: 'Puyang', slug: 'puyang' },
  { name: 'Yokohama', slug: 'yokohama' },
  { name: 'Ibadan', slug: 'ibadan' },
  { name: 'Singapore', slug: 'singapore' },
  { name: 'Wuxi', slug: 'wuxi' },
  { name: 'Xiamen', slug: 'xiamen' },
  { name: 'Ankara', slug: 'ankara' },
  { name: 'Tianshui', slug: 'tianshui' },
  { name: 'Ningbo', slug: 'ningbo' },
  { name: 'Ho Chi Minh City', slug: 'ho-chi-minh-city' },
  { name: 'Shiyan', slug: 'shiyan' },
  { name: 'Cape Town', slug: 'cape-town' },
  { name: 'Taiyuan', slug: 'taiyuan' },
  { name: 'Berlin', slug: 'berlin' },
  { name: 'Tangshan', slug: 'tangshan' },
  { name: 'Hefei', slug: 'hefei' },
  { name: 'Madrid', slug: 'madrid' },
  { name: 'Pyongyang', slug: 'pyongyang' },
  { name: 'Casablanca', slug: 'casablanca' },
  { name: 'Zibo', slug: 'zibo' },
  { name: 'Zhongshan', slug: 'zhongshan' },
  { name: 'Durban', slug: 'durban' },
  { name: 'Changsha', slug: 'changsha' },
  { name: 'Kabul', slug: 'kabul' },
  { name: 'Ürümqi', slug: 'urumqi' },
  { name: 'Caracas', slug: 'caracas' },
  { name: 'Dubai', slug: 'dubai' },
  { name: 'Jeddah', slug: 'jeddah' },
  { name: 'Shijiazhuang', slug: 'shijiazhuang' },
  { name: 'Kyiv', slug: 'kyiv' },
  { name: 'Luanda', slug: 'luanda' },
  { name: 'Quezon City', slug: 'quezon-city' },
  { name: 'Addis Ababa', slug: 'addis-ababa' },
  { name: 'Nairobi', slug: 'nairobi' },
  { name: 'Chicago', slug: 'chicago' },
  { name: 'Salvador', slug: 'salvador' },
  { name: 'Dar es Salaam', slug: 'dar-es-salaam' },
  { name: 'Lanzhou', slug: 'lanzhou' },
  { name: 'Incheon', slug: 'incheon' },
  { name: 'Yunfu', slug: 'yunfu' },
  { name: 'Toronto', slug: 'toronto' },
  { name: 'Navi Mumbai', slug: 'navi-mumbai' },
  { name: 'Basrah', slug: 'basrah' },
  { name: 'Osaka', slug: 'osaka' },
  { name: 'Mogadishu', slug: 'mogadishu' },
  { name: 'Daegu', slug: 'daegu' },
  { name: 'Faisalabad', slug: 'faisalabad' },
  { name: 'İzmir', slug: 'izmir' },
  { name: 'Dakar', slug: 'dakar' },
  { name: 'Giza', slug: 'giza' },
  { name: 'Fortaleza', slug: 'fortaleza' },
  { name: 'Cali', slug: 'cali' },
  { name: 'Surabaya', slug: 'surabaya' },
  { name: 'Belo Horizonte', slug: 'belo-horizonte' },
  { name: 'Nanchang', slug: 'nanchang' },
  { name: 'Rome', slug: 'rome' },
  { name: 'Mashhad', slug: 'mashhad' },
  { name: 'Brooklyn', slug: 'brooklyn' },
  { name: 'Houston', slug: 'houston' },
  { name: 'Queens', slug: 'queens' },
  { name: 'Maracaibo', slug: 'maracaibo' },
  { name: 'Brasília', slug: 'brasilia' },
  { name: 'Santo Domingo', slug: 'santo-domingo' },
  { name: 'Nagoya', slug: 'nagoya' },
  { name: 'Brisbane', slug: 'brisbane' },
  { name: 'Havana', slug: 'havana' },
  { name: 'Paris', slug: 'paris' },
  { name: 'Al Mawşil al Jadīdah', slug: 'al-mawsil-al-jadidah' },
  { name: 'Johannesburg', slug: 'johannesburg' },
  { name: 'Kowloon', slug: 'kowloon' },
  { name: 'Al Başrah al Qadīmah', slug: 'al-basrah-al-qadimah' },
  { name: 'Almaty', slug: 'almaty' },
  { name: 'Dadonghai', slug: 'dadonghai' },
  { name: 'Medellín', slug: 'medellin' },
  { name: 'Tashkent', slug: 'tashkent' },
  { name: 'Algiers', slug: 'algiers' },
  { name: 'Khartoum', slug: 'khartoum' },
  { name: 'Accra', slug: 'accra' },
  { name: 'Guayaquil', slug: 'guayaquil' },
  { name: 'Ordos', slug: 'ordos' },
  { name: 'Sanaa', slug: 'sanaa' },
  { name: 'Beirut', slug: 'beirut' },
  { name: 'Perth', slug: 'perth' },
  { name: 'Sapporo', slug: 'sapporo' },
  { name: 'Jilin', slug: 'jilin' },
  { name: 'Bucharest', slug: 'bucharest' },
  { name: 'Camayenne', slug: 'camayenne' },
  { name: 'Iztapalapa', slug: 'iztapalapa' },
  { name: 'Conakry', slug: 'conakry' },
  { name: 'Bayan Nur', slug: 'bayan-nur' },
  { name: 'Maracay', slug: 'maracay' },
  { name: 'Medan', slug: 'medan' },
  { name: 'Rawalpindi', slug: 'rawalpindi' },
  { name: 'Minsk', slug: 'minsk' },
  { name: 'Budapest', slug: 'budapest' },
  { name: 'Mosul', slug: 'mosul' },
  { name: 'Hamburg', slug: 'hamburg' },
  { name: 'Curitiba', slug: 'curitiba' },
  { name: 'Warsaw', slug: 'warsaw' },
  { name: 'Bandung', slug: 'bandung' },
  { name: 'Soweto', slug: 'soweto' },
  { name: 'Vienna', slug: 'vienna' },
  { name: 'Rabat', slug: 'rabat' },
  { name: 'Ecatepec de Morelos', slug: 'ecatepec-de-morelos' },
  { name: 'Barcelona', slug: 'barcelona' },
  { name: 'Pretoria', slug: 'pretoria' },
  { name: 'Aleppo', slug: 'aleppo' },
  { name: 'Montréal', slug: 'montreal' },
  { name: 'Kunshan', slug: 'kunshan' },
  { name: 'Manila', slug: 'manila' },
  { name: 'Manaus', slug: 'manaus' },
  { name: 'Xinyang', slug: 'xinyang' },
  { name: 'Kaduna', slug: 'kaduna' },
  { name: 'Phnom Penh', slug: 'phnom-penh' },
  { name: 'Damascus', slug: 'damascus' },
  { name: 'Philadelphia', slug: 'philadelphia' },
  { name: 'Phoenix', slug: 'phoenix' },
  { name: 'Isfahan', slug: 'isfahan' },
  { name: 'Ludhiāna', slug: 'ludhiana' },
  { name: 'Harare', slug: 'harare' },
  { name: 'Kobe', slug: 'kobe' },
  { name: 'Bekasi', slug: 'bekasi' },
  { name: 'Kaohsiung', slug: 'kaohsiung' },
  { name: 'Stockholm', slug: 'stockholm' },
  { name: 'Caloocan City', slug: 'caloocan-city' },
  { name: 'Guadalajara', slug: 'guadalajara' },
  { name: 'Manhattan', slug: 'manhattan' },
  { name: 'Asunción', slug: 'asuncion' },
  { name: 'Recife', slug: 'recife' },
  { name: 'Daejeon', slug: 'daejeon' },
  { name: 'San Antonio', slug: 'san-antonio' },
  { name: 'Kumasi', slug: 'kumasi' },
  { name: 'Kota Bharu', slug: 'kota-bharu' },
  { name: 'Kyoto', slug: 'kyoto' },
  { name: 'Kuala Lumpur', slug: 'kuala-lumpur' },
  { name: 'Karaj', slug: 'karaj' },
  { name: 'Kathmandu', slug: 'kathmandu' },
  { name: 'Palembang', slug: 'palembang' },
  { name: 'Multan', slug: 'multan' },
  { name: 'Tirunelveli', slug: 'tirunelveli' },
  { name: 'Puebla', slug: 'puebla' },
  { name: 'Hanoi', slug: 'hanoi' },
  { name: 'Kharkiv', slug: 'kharkiv' },
  { name: 'Agra', slug: 'agra' },
  { name: 'Córdoba', slug: 'cordoba' },
  { name: 'Tabriz', slug: 'tabriz' },
  { name: 'Novosibirsk', slug: 'novosibirsk' },
  { name: 'Gwangju', slug: 'gwangju' },
  { name: 'Bursa', slug: 'bursa' },
  { name: 'Vadodara', slug: 'vadodara' },
  { name: 'Belém', slug: 'belem' },
  { name: 'Fushun', slug: 'fushun' },
  { name: 'Quito', slug: 'quito' },
  { name: 'San Diego', slug: 'san-diego' },
  { name: 'Fukuoka', slug: 'fukuoka' },
  { name: 'Antananarivo', slug: 'antananarivo' },
  { name: 'Luoyang', slug: 'luoyang' },
  { name: 'The Bronx', slug: 'the-bronx' },
  { name: 'Valencia', slug: 'valencia' },
  { name: 'Gujranwala', slug: 'gujranwala' },
  { name: 'Barranquilla', slug: 'barranquilla' },
  { name: 'Guankou', slug: 'guankou' },
  { name: 'Lubumbashi', slug: 'lubumbashi' },
  { name: 'Porto Alegre', slug: 'porto-alegre' },
  { name: 'Tangerang', slug: 'tangerang' },
  { name: 'Najafgarh', slug: 'najafgarh' },
  { name: 'Santa Cruz de la Sierra', slug: 'santa-cruz-de-la-sierra' },
  { name: 'Handan', slug: 'handan' },
  { name: 'Kampala', slug: 'kampala' },
  { name: 'Yekaterinburg', slug: 'yekaterinburg' },
  { name: 'Khulna', slug: 'khulna' },
  { name: 'Douala', slug: 'douala' },
  { name: 'Gorakhpur', slug: 'gorakhpur' },
  { name: 'Sharjah', slug: 'sharjah' },
  { name: 'Mecca', slug: 'mecca' },
  { name: 'Makassar', slug: 'makassar' },
  { name: 'Juárez', slug: 'juarez' },
  { name: 'Kawasaki', slug: 'kawasaki' },
  { name: 'South Tangerang', slug: 'south-tangerang' },
  { name: 'Baotou', slug: 'baotou' },
  { name: 'Tijuana', slug: 'tijuana' },
  { name: 'Dallas', slug: 'dallas' },
  { name: 'Medina', slug: 'medina' },
  { name: 'Yaoundé', slug: 'yaounde' },
  { name: 'Bamako', slug: 'bamako' },
  { name: 'Nashik', slug: 'nashik' },
  { name: 'Semarang', slug: 'semarang' },
  { name: 'Brazzaville', slug: 'brazzaville' },
  { name: 'Pimpri', slug: 'pimpri' },
  { name: 'Nizhniy Novgorod', slug: 'nizhniy-novgorod' },
  { name: 'Amman', slug: 'amman' },
  { name: 'Budta', slug: 'budta' },
  { name: 'Belgrade', slug: 'belgrade' },
  { name: 'Montevideo', slug: 'montevideo' },
  { name: 'Lusaka', slug: 'lusaka' },
  { name: 'Xuchang', slug: 'xuchang' },
  { name: 'Kalyān', slug: 'kalyan' },
  { name: 'Munich', slug: 'munich' },
  { name: 'Ra’s Bayrūt', slug: 'ras-bayrut' },
  { name: 'Shiraz', slug: 'shiraz' },
  { name: 'Adana', slug: 'adana' },
  { name: 'Suwon', slug: 'suwon' },
  { name: 'León de los Aldama', slug: 'leon-de-los-aldama' },
  { name: 'Milan', slug: 'milan' },
  { name: 'Port-au-Prince', slug: 'port-au-prince' },
  { name: 'Adelaide', slug: 'adelaide' },
  { name: 'Meerut', slug: 'meerut' },
  { name: 'Nowrangapur', slug: 'nowrangapur' },
  { name: 'Faridabad', slug: 'faridabad' },
  { name: 'Peshawar', slug: 'peshawar' },
  { name: 'Davao', slug: 'davao' },
  { name: 'Mandalay', slug: 'mandalay' },
  { name: 'Yueyang', slug: 'yueyang' },
  { name: 'Santiago de los Caballeros', slug: 'santiago-de-los-caballeros' },
  { name: 'Omdurman', slug: 'omdurman' },
  { name: 'Anshan', slug: 'anshan' },
  { name: 'Tongshan', slug: 'tongshan' },
  { name: 'Ghāziābād', slug: 'ghaziabad' },
  { name: 'Depok', slug: 'depok' },
  { name: 'Saitama', slug: 'saitama' },
  { name: 'Dombivli', slug: 'dombivli' },
  { name: 'Maputo', slug: 'maputo' },
  { name: 'Gustavo Adolfo Madero', slug: 'gustavo-adolfo-madero' },
  { name: 'Fuzhou', slug: 'fuzhou' },
  { name: 'Rājkot', slug: 'rajkot' },
  { name: 'Rosario', slug: 'rosario' },
  { name: 'Guiyang', slug: 'guiyang' },
  { name: 'Goiânia', slug: 'goiania' },
  { name: 'Guarulhos', slug: 'guarulhos' },
  { name: 'Prague', slug: 'prague' },
  { name: 'Varanasi', slug: 'varanasi' },
  { name: 'Batam', slug: 'batam' },
  { name: 'Copenhagen', slug: 'copenhagen' },
  { name: 'Sofia', slug: 'sofia' },
  { name: 'Tripoli', slug: 'tripoli' },
  { name: 'Port Harcourt', slug: 'port-harcourt' },
  { name: 'Hiroshima', slug: 'hiroshima' },
  { name: 'Zapopan', slug: 'zapopan' },
  { name: 'Lijiang', slug: 'lijiang' },
  { name: 'Monterrey', slug: 'monterrey' },
  { name: 'Samara', slug: 'samara' },
  { name: 'Omsk', slug: 'omsk' },
  { name: 'Benin City', slug: 'benin-city' },
  { name: 'Malingao', slug: 'malingao' },
  { name: 'Baku', slug: 'baku' },
  { name: 'Maiduguri', slug: 'maiduguri' },
  { name: 'Kazan', slug: 'kazan' },
  { name: 'Ciudad Nezahualcoyotl', slug: 'ciudad-nezahualcoyotl' },
  { name: 'Yerevan', slug: 'yerevan' },
  { name: 'Amritsar', slug: 'amritsar' },
  { name: 'Ouagadougou', slug: 'ouagadougou' },
  { name: 'Yono', slug: 'yono' },
  { name: 'Rostov-na-Donu', slug: 'rostov-na-donu' },
  { name: 'Allahābād', slug: 'allahabad' },
  { name: 'Goyang-si', slug: 'goyang-si' },
  { name: 'Gaziantep', slug: 'gaziantep' },
  { name: 'Sendai', slug: 'sendai' },
  { name: 'Chelyabinsk', slug: 'chelyabinsk' },
  { name: 'Datong', slug: 'datong' },
  { name: 'Tbilisi', slug: 'tbilisi' },
  { name: 'Changshu City', slug: 'changshu-city' },
  { name: 'Taichung', slug: 'taichung' },
  { name: 'Teni', slug: 'teni' },
  { name: 'Xianyang', slug: 'xianyang' },
  { name: 'Ufa', slug: 'ufa' },
  { name: 'Dnipro', slug: 'dnipro' },
  { name: 'Seongnam-si', slug: 'seongnam-si' },
  { name: 'Campinas', slug: 'campinas' },
  { name: 'Jabalpur', slug: 'jabalpur' },
  { name: 'Hāora', slug: 'haora' },
  { name: 'Huainan', slug: 'huainan' },
  { name: 'San Jose', slug: 'san-jose' },
  { name: 'Donetsk', slug: 'donetsk' },
  { name: 'Dublin', slug: 'dublin' },
  { name: 'Calgary', slug: 'calgary' },
  { name: 'Brussels', slug: 'brussels' },
  { name: 'Aurangabad', slug: 'aurangabad' },
  { name: 'Volgograd', slug: 'volgograd' },
  { name: 'Nova Iguaçu', slug: 'nova-iguacu' },
  { name: 'Jieyang', slug: 'jieyang' },
  { name: 'Odessa', slug: 'odessa' },
  { name: 'Zhu Cheng City', slug: 'zhu-cheng-city' },
  { name: 'Shivaji Nagar', slug: 'shivaji-nagar' },
  { name: 'Kitakyushu', slug: 'kitakyushu' },
  { name: 'Solāpur', slug: 'solapur' },
  { name: 'Baoding', slug: 'baoding' },
  { name: 'Guatemala City', slug: 'guatemala-city' },
  { name: 'Benxi', slug: 'benxi' },
  { name: 'Birmingham', slug: 'birmingham' },
  { name: 'Perm', slug: 'perm' },
  { name: 'Srinagar', slug: 'srinagar' },
  { name: 'Zaria', slug: 'zaria' },
  { name: 'Managua', slug: 'managua' },
  { name: 'Port Elizabeth', slug: 'port-elizabeth' },
  { name: 'Fès', slug: 'fes' },
  { name: 'Köln', slug: 'koln' },
  { name: 'Ulsan', slug: 'ulsan' },
  { name: 'Naples', slug: 'naples' },
  { name: 'Maceió', slug: 'maceio' },
  { name: 'Cartagena', slug: 'cartagena' },
  { name: 'Changzhou', slug: 'changzhou' },
  { name: 'Sulţānah', slug: 'sultanah' },
  { name: 'Monrovia', slug: 'monrovia' },
  { name: 'Kingston', slug: 'kingston' },
  { name: 'Erbil', slug: 'erbil' },
  { name: 'Austin', slug: 'austin' },
  { name: 'Krasnoyarsk', slug: 'krasnoyarsk' },
  { name: 'Nay Pyi Taw', slug: 'nay-pyi-taw' },
  { name: 'Jodhpur', slug: 'jodhpur' },
  { name: 'Chiba', slug: 'chiba' },
  { name: 'São Luís', slug: 'sao-luis' },
  { name: 'Madurai', slug: 'madurai' },
  { name: 'Sale', slug: 'sale' },
  { name: 'Huaibei', slug: 'huaibei' },
  { name: 'Cochabamba', slug: 'cochabamba' },
  { name: 'Abobo', slug: 'abobo' },
  { name: 'Kaifeng', slug: 'kaifeng' },
  { name: 'Abū Ghurayb', slug: 'abu-ghurayb' },
  { name: 'Qom', slug: 'qom' },
  { name: 'Bishkek', slug: 'bishkek' },
  { name: 'Aba', slug: 'aba' },
  { name: 'Pingdingshan', slug: 'pingdingshan' },
  { name: 'Gwalior', slug: 'gwalior' },
  { name: 'Qiqihar', slug: 'qiqihar' },
  { name: 'Klang', slug: 'klang' },
  { name: 'Mendoza', slug: 'mendoza' },
  { name: 'Konya', slug: 'konya' },
  { name: 'Mbuji-Mayi', slug: 'mbuji-mayi' },
  { name: 'Vijayawada', slug: 'vijayawada' },
  { name: 'Pikine', slug: 'pikine' },
  { name: 'Turin', slug: 'turin' },
  { name: 'Mysore', slug: 'mysore' },
  { name: 'Jacksonville', slug: 'jacksonville' },
  { name: 'Wenzhou', slug: 'wenzhou' },
  { name: 'San Francisco', slug: 'san-francisco' },
  { name: 'Liverpool', slug: 'liverpool' },
  { name: 'Saratov', slug: 'saratov' },
  { name: 'Rohini', slug: 'rohini' },
  { name: 'Tegucigalpa', slug: 'tegucigalpa' },
  { name: 'Bucheon-si', slug: 'bucheon-si' },
  { name: 'Columbus', slug: 'columbus' },
  { name: 'Voronezh', slug: 'voronezh' },
  { name: 'Ranchi', slug: 'ranchi' },
  { name: 'Ulan Bator', slug: 'ulan-bator' },
  { name: 'Takeo', slug: 'takeo' },
  { name: 'Ahvaz', slug: 'ahvaz' },
  { name: 'Arequipa', slug: 'arequipa' },
  { name: 'Padang', slug: 'padang' },
  { name: 'Hubli', slug: 'hubli' },
  { name: 'Zhabei', slug: 'zhabei' },
  { name: 'Marrakesh', slug: 'marrakesh' },
  { name: 'Denpasar', slug: 'denpasar' },
  { name: 'Kampung Baru Subang', slug: 'kampung-baru-subang' },
  { name: 'Fort Worth', slug: 'fort-worth' },
  { name: 'Indianapolis', slug: 'indianapolis' },
  { name: 'Charlotte', slug: 'charlotte' },
  { name: 'Duque de Caxias', slug: 'duque-de-caxias' },
  { name: 'Jos', slug: 'jos' },
  { name: 'Ilorin', slug: 'ilorin' },
  { name: 'Callao', slug: 'callao' },
  { name: 'La Paz', slug: 'la-paz' },
  { name: 'Ottawa', slug: 'ottawa' },
  { name: 'Barquisimeto', slug: 'barquisimeto' },
  { name: 'Chihuahua', slug: 'chihuahua' },
  { name: 'Nanning', slug: 'nanning' },
  { name: 'Freetown', slug: 'freetown' },
  { name: 'Johor Bahru', slug: 'johor-bahru' },
  { name: 'Jerusalem', slug: 'jerusalem' },
  { name: 'Bandar Lampung', slug: 'bandar-lampung' },
  { name: 'Bogor', slug: 'bogor' },
  { name: 'Narela', slug: 'narela' },
  { name: 'Mombasa', slug: 'mombasa' },
  { name: 'Cebu City', slug: 'cebu-city' },
  { name: 'Muscat', slug: 'muscat' },
  { name: 'Zaporizhia', slug: 'zaporizhia' },
  { name: 'Marseille', slug: 'marseille' },
  { name: 'Zarqa', slug: 'zarqa' },
  { name: 'Naucalpan de Juárez', slug: 'naucalpan-de-juarez' },
  { name: 'Çankaya', slug: 'cankaya' },
  { name: 'Rahim Yar Khan', slug: 'rahim-yar-khan' },
  { name: 'Pasragad Branch', slug: 'pasragad-branch' },
  { name: 'Boumerdas', slug: 'boumerdas' },
  { name: 'Jalandhar', slug: 'jalandhar' },
  { name: 'Thiruvananthapuram', slug: 'thiruvananthapuram' },
  { name: 'Sakai', slug: 'sakai' },
  { name: 'Anyang', slug: 'anyang' },
  { name: 'San Miguel de Tucumán', slug: 'san-miguel-de-tucuman' },
  { name: 'Cotonou', slug: 'cotonou' },
  { name: 'Salem', slug: 'salem' },
  { name: 'Mérida', slug: 'merida' },
  { name: 'Tiruchirappalli', slug: 'tiruchirappalli' },
  { name: 'Homs', slug: 'homs' },
  { name: 'Hohhot', slug: 'hohhot' },
  { name: 'Niamey', slug: 'niamey' },
  { name: 'Tainan', slug: 'tainan' },
  { name: 'Shangyu', slug: 'shangyu' },
  { name: 'Łódź', slug: 'odz' },
  { name: 'Dammam', slug: 'dammam' },
  { name: 'Xining', slug: 'xining' },
  { name: 'Kahrīz', slug: 'kahriz' },
  { name: 'Kota', slug: 'kota' },
  { name: 'Natal', slug: 'natal' },
  { name: 'Bhubaneshwar', slug: 'bhubaneshwar' },
  { name: 'Qinhuangdao', slug: 'qinhuangdao' },
  { name: 'Hengyang', slug: 'hengyang' },
  { name: 'Antalya', slug: 'antalya' },
  { name: 'Kraków', slug: 'krakow' },
  { name: 'Alīgarh', slug: 'aligarh' },
  { name: 'Da Nang', slug: 'da-nang' },
  { name: 'Pietermaritzburg', slug: 'pietermaritzburg' },
  { name: 'Lomé', slug: 'lome' },
  { name: 'Trujillo', slug: 'trujillo' },
  { name: 'Malang', slug: 'malang' },
  { name: 'Ciudad Guayana', slug: 'ciudad-guayana' },
  { name: 'Bareilly', slug: 'bareilly' },
  { name: 'Kigali', slug: 'kigali' },
  { name: 'Teresina', slug: 'teresina' },
  { name: 'Xinxiang', slug: 'xinxiang' },
  { name: 'São Bernardo do Campo', slug: 'sao-bernardo-do-campo' },
  { name: 'Hegang', slug: 'hegang' },
  { name: 'Riga', slug: 'riga' },
  { name: 'Amsterdam', slug: 'amsterdam' },
  { name: 'Oyo', slug: 'oyo' },
  { name: 'Quetta', slug: 'quetta' },
  { name: 'Nottingham', slug: 'nottingham' },
  { name: 'Campo Grande', slug: 'campo-grande' },
  { name: 'Ashgabat', slug: 'ashgabat' },
  { name: 'Álvaro Obregón', slug: 'alvaro-obregon' },
  { name: 'Muzaffarābād', slug: 'muzaffarabad' },
  { name: 'Bağcılar', slug: 'bagclar' },
  { name: 'As Sulaymānīyah', slug: 'as-sulaymaniyah' },
  { name: 'San Luis Potosí', slug: 'san-luis-potosi' },
  { name: 'Aguascalientes', slug: 'aguascalientes' },
  { name: 'Cúcuta', slug: 'cucuta' },
  { name: 'Morādābād', slug: 'moradabad' },
  { name: 'N\'Djamena', slug: 'ndjamena' },
  { name: 'Langfang', slug: 'langfang' },
  { name: 'Zhumadian', slug: 'zhumadian' },
  { name: 'Yantai', slug: 'yantai' },
  { name: 'Lviv', slug: 'lviv' },
  { name: 'Hermosillo', slug: 'hermosillo' },
  { name: 'Edmonton', slug: 'edmonton' },
  { name: 'Jeonju', slug: 'jeonju' },
  { name: 'Saltillo', slug: 'saltillo' },
  { name: 'Zhuzhou', slug: 'zhuzhou' },
  { name: 'Subang Jaya', slug: 'subang-jaya' },
  { name: 'Bhiwandi', slug: 'bhiwandi' },
  { name: 'Pekanbaru', slug: 'pekanbaru' },
  { name: 'Sevilla', slug: 'sevilla' },
  { name: 'Tol’yatti', slug: 'tolyatti' },
  { name: 'Jaboatão', slug: 'jaboatao' },
  { name: 'Shizuoka', slug: 'shizuoka' },
  { name: 'Santo Domingo Oeste', slug: 'santo-domingo-oeste' },
  { name: 'Rājshāhi', slug: 'rajshahi' },
  { name: 'Santo Domingo Este', slug: 'santo-domingo-este' },
  { name: 'City of Balikpapan', slug: 'city-of-balikpapan' },
  { name: 'Battagram', slug: 'battagram' },
  { name: 'Changzhi', slug: 'changzhi' },
  { name: 'Bulawayo', slug: 'bulawayo' },
  { name: 'Zagreb', slug: 'zagreb' },
  { name: 'Agadir', slug: 'agadir' },
  { name: 'Sarajevo', slug: 'sarajevo' },
  { name: 'La Plata', slug: 'la-plata' },
  { name: 'Tunis', slug: 'tunis' },
  { name: 'Zhangjiakou', slug: 'zhangjiakou' },
  { name: 'Zigong', slug: 'zigong' },
  { name: 'Mexicali', slug: 'mexicali' },
  { name: 'Fuxin', slug: 'fuxin' },
  { name: 'Enugu', slug: 'enugu' },
  { name: 'Tangier', slug: 'tangier' },
  { name: 'Huangshi', slug: 'huangshi' },
  { name: 'Liaoyang', slug: 'liaoyang' },
  { name: 'Sheffield', slug: 'sheffield' },
  { name: 'Seattle', slug: 'seattle' },
  { name: 'Denver', slug: 'denver' },
  { name: 'El Paso', slug: 'el-paso' },
  { name: 'Kumamoto', slug: 'kumamoto' },
  { name: 'Raipur', slug: 'raipur' },
  { name: 'General Santos', slug: 'general-santos' },
  { name: 'Dushanbe', slug: 'dushanbe' },
  { name: 'Osasco', slug: 'osasco' },
  { name: 'Detroit', slug: 'detroit' },
  { name: 'Culiacán', slug: 'culiacan' },
  { name: 'Matola', slug: 'matola' },
  { name: 'Zaragoza', slug: 'zaragoza' },
  { name: 'Xiangtan', slug: 'xiangtan' },
  { name: 'Guadalupe', slug: 'guadalupe' },
  { name: 'Acapulco de Juárez', slug: 'acapulco-de-juarez' },
  { name: 'Ipoh', slug: 'ipoh' },
  { name: 'Mississauga', slug: 'mississauga' },
  { name: 'Boston', slug: 'boston' },
  { name: 'Puyang Chengguanzhen', slug: 'puyang-chengguanzhen' },
  { name: 'Nantong', slug: 'nantong' },
  { name: 'Mudanjiang', slug: 'mudanjiang' },
  { name: 'Athens', slug: 'athens' },
  { name: 'Santo André', slug: 'santo-andre' },
  { name: 'Nouakchott', slug: 'nouakchott' },
  { name: 'Pointe-Noire', slug: 'pointe-noire' },
  { name: 'Memphis', slug: 'memphis' },
  { name: 'Tlalnepantla', slug: 'tlalnepantla' },
  { name: 'Kryvyi Rih', slug: 'kryvyi-rih' },
  { name: 'João Pessoa', slug: 'joao-pessoa' },
  { name: 'Ansan-si', slug: 'ansan-si' },
  { name: 'Benghazi', slug: 'benghazi' },
  { name: 'Frankfurt am Main', slug: 'frankfurt-am-main' },
  { name: 'Krasnodar', slug: 'krasnodar' },
  { name: 'Guilin', slug: 'guilin' },
  { name: 'Palermo', slug: 'palermo' },
  { name: 'Colombo', slug: 'colombo' },
  { name: 'Lilongwe', slug: 'lilongwe' },
  { name: 'Oran', slug: 'oran' },
  { name: 'Diyarbakır', slug: 'diyarbakr' },
  { name: 'Taguig', slug: 'taguig' },
  { name: 'New South Memphis', slug: 'new-south-memphis' },
  { name: 'Ulyanovsk', slug: 'ulyanovsk' },
  { name: 'Kotli', slug: 'kotli' },
  { name: 'Okayama', slug: 'okayama' },
  { name: 'Zhanjiang', slug: 'zhanjiang' },
  { name: 'Al Aḩmadī', slug: 'al-ahmadi' },
  { name: 'Yogyakarta', slug: 'yogyakarta' },
  { name: 'North York', slug: 'north-york' },
  { name: 'Chisinau', slug: 'chisinau' },
  { name: 'Wrocław', slug: 'wrocaw' },
  { name: 'Cheongju-si', slug: 'cheongju-si' },
  { name: 'Anyang-si', slug: 'anyang-si' },
  { name: 'Tébessa', slug: 'tebessa' },
  { name: 'Zhenjiang', slug: 'zhenjiang' },
  { name: 'Portland', slug: 'portland' },
  { name: 'Winnipeg', slug: 'winnipeg' },
  { name: 'Dandong', slug: 'dandong' },
  { name: 'Oklahoma City', slug: 'oklahoma-city' },
  { name: 'Izhevsk', slug: 'izhevsk' },
  { name: 'Jaboatão dos Guararapes', slug: 'jaboatao-dos-guararapes' },
  { name: 'Shaoguan', slug: 'shaoguan' },
  { name: 'Yancheng', slug: 'yancheng' },
  { name: 'Cancún', slug: 'cancun' },
  { name: 'Contagem', slug: 'contagem' },
  { name: 'Santiago de Querétaro', slug: 'santiago-de-queretaro' },
  { name: 'Bhilai', slug: 'bhilai' },
  { name: 'Panshan', slug: 'panshan' },
  { name: 'Djibouti', slug: 'djibouti' },
  { name: 'Las Vegas', slug: 'las-vegas' },
  { name: 'Baltimore', slug: 'baltimore' },
  { name: 'Kermanshah', slug: 'kermanshah' },
  { name: 'Coyoacán', slug: 'coyoacan' },
  { name: 'Ribeirão Preto', slug: 'ribeirao-preto' },
  { name: 'Al Ḩudaydah', slug: 'al-hudaydah' },
  { name: 'Pasig City', slug: 'pasig-city' },
  { name: 'Bristol', slug: 'bristol' },
  { name: 'Jamshedpur', slug: 'jamshedpur' },
  { name: 'Haikou', slug: 'haikou' },
  { name: 'Ta‘izz', slug: 'taizz' },
  { name: 'São José dos Campos', slug: 'sao-jose-dos-campos' },
  { name: 'Santa María Chimalhuacán', slug: 'santa-maria-chimalhuacan' },
  { name: 'Taizhou', slug: 'taizhou' },
  { name: 'Xingtai', slug: 'xingtai' },
  { name: 'Borivli', slug: 'borivli' },
  { name: 'Torreón', slug: 'torreon' },
  { name: 'Yaroslavl', slug: 'yaroslavl' },
  { name: 'Benoni', slug: 'benoni' },
  { name: 'Hamamatsu', slug: 'hamamatsu' },
  { name: 'Cochin', slug: 'cochin' },
  { name: 'Jinzhou', slug: 'jinzhou' },
  { name: 'Amrāvati', slug: 'amravati' },
  { name: 'Abu Dhabi', slug: 'abu-dhabi' },
  { name: 'Haiphong', slug: 'haiphong' },
  { name: 'Washington, D.C.', slug: 'washington-dc' },
  { name: 'Islamabad', slug: 'islamabad' },
  { name: 'Kirkuk', slug: 'kirkuk' },
  { name: 'Sāngli', slug: 'sangli' },
  { name: 'Milwaukee', slug: 'milwaukee' },
  { name: 'Vancouver', slug: 'vancouver' },
  { name: 'Scarborough', slug: 'scarborough' },
  { name: 'Shuangyashan', slug: 'shuangyashan' },
  { name: 'Situbondo', slug: 'situbondo' },
  { name: 'Barnaul', slug: 'barnaul' },
  { name: 'Rotterdam', slug: 'rotterdam' },
  { name: 'Morelia', slug: 'morelia' },
  { name: 'Luancheng', slug: 'luancheng' },
  { name: 'Rasht', slug: 'rasht' },
  { name: 'Abeokuta', slug: 'abeokuta' },
  { name: 'Essen', slug: 'essen' },
  { name: 'Kayseri', slug: 'kayseri' },
  { name: 'Glasgow', slug: 'glasgow' },
  { name: 'Gold Coast', slug: 'gold-coast' },
  { name: 'Yingkou', slug: 'yingkou' },
  { name: 'Abuja', slug: 'abuja' },
  { name: 'Las Piñas', slug: 'las-pinas' },
  { name: 'Zhangzhou', slug: 'zhangzhou' },
  { name: 'Stuttgart', slug: 'stuttgart' },
  { name: 'Reynosa', slug: 'reynosa' },
  { name: 'Dortmund', slug: 'dortmund' },
  { name: 'Vladivostok', slug: 'vladivostok' },
  { name: 'Irkutsk', slug: 'irkutsk' },
  { name: 'Blantyre', slug: 'blantyre' },
  { name: 'New Kingston', slug: 'new-kingston' },
  { name: 'Üsküdar', slug: 'uskudar' },
  { name: 'Genoa', slug: 'genoa' },
  { name: 'Cuttack', slug: 'cuttack' },
  { name: 'Oslo', slug: 'oslo' },
  { name: 'Hachiōji', slug: 'hachioji' },
  { name: 'Khabarovsk', slug: 'khabarovsk' },
  { name: 'Khabarovsk Vtoroy', slug: 'khabarovsk-vtoroy' },
  { name: 'Libreville', slug: 'libreville' },
  { name: 'Kerman', slug: 'kerman' },
  { name: 'Chiclayo', slug: 'chiclayo' },
  { name: 'Orūmīyeh', slug: 'orumiyeh' },
  { name: 'Bahçelievler', slug: 'bahcelievler' },
  { name: 'Bengbu', slug: 'bengbu' },
  { name: 'Bīkaner', slug: 'bikaner' },
  { name: 'Tlaquepaque', slug: 'tlaquepaque' },
  { name: 'Tlalpan', slug: 'tlalpan' },
  { name: 'Umraniye', slug: 'umraniye' },
  { name: 'Düsseldorf', slug: 'dusseldorf' },
  { name: 'Banjarmasin', slug: 'banjarmasin' },
  { name: 'Göteborg', slug: 'goteborg' },
  { name: 'Shihezi', slug: 'shihezi' },
  { name: 'Bucaramanga', slug: 'bucaramanga' },
  { name: 'South Boston', slug: 'south-boston' },
  { name: 'Kuching', slug: 'kuching' },
  { name: 'Poznań', slug: 'poznan' },
  { name: 'Málaga', slug: 'malaga' },
  { name: 'Bouaké', slug: 'bouake' },
  { name: 'Nyala', slug: 'nyala' },
  { name: 'Asmara', slug: 'asmara' },
  { name: 'Sokoto', slug: 'sokoto' },
  { name: 'Uberlândia', slug: 'uberlandia' },
  { name: 'Onitsha', slug: 'onitsha' },
  { name: 'Honchō', slug: 'honcho' },
  { name: 'Albuquerque', slug: 'albuquerque' },
  { name: 'Hamhŭng', slug: 'hamhung' },
  { name: 'Sorocaba', slug: 'sorocaba' },
  { name: 'Helsinki', slug: 'helsinki' },
  { name: 'Warangal', slug: 'warangal' },
  { name: 'Santiago de Cuba', slug: 'santiago-de-cuba' },
  { name: 'Siping', slug: 'siping' },
  { name: 'Kagoshima', slug: 'kagoshima' },
  { name: 'Surakarta', slug: 'surakarta' },
  { name: 'Huai\'an', slug: 'huaian' },
  { name: 'Bhavnagar', slug: 'bhavnagar' },
  { name: 'Mar del Plata', slug: 'mar-del-plata' },
  { name: 'Bahawalpur', slug: 'bahawalpur' },
  { name: 'Zahedan', slug: 'zahedan' },
  { name: 'Aden', slug: 'aden' },
  { name: 'Nanded', slug: 'nanded' },
  { name: 'Orenburg', slug: 'orenburg' },
  { name: 'Changwon', slug: 'changwon' },
  { name: 'Pristina', slug: 'pristina' },
  { name: 'Jiamusi', slug: 'jiamusi' },
  { name: 'Antipolo', slug: 'antipolo' },
  { name: 'Neijiang', slug: 'neijiang' },
  { name: 'Bremen', slug: 'bremen' },
  { name: 'Meknès', slug: 'meknes' },
  { name: 'Banqiao', slug: 'banqiao' },
  { name: 'Sargodha', slug: 'sargodha' },
  { name: 'Bangui', slug: 'bangui' },
  { name: 'Vilnius', slug: 'vilnius' },
  { name: 'Yangzhou', slug: 'yangzhou' },
  { name: 'Novokuznetsk', slug: 'novokuznetsk' },
  { name: 'Kisangani', slug: 'kisangani' },
  { name: 'Port Said', slug: 'port-said' },
  { name: 'Mersin', slug: 'mersin' },
  { name: 'Tuxtla', slug: 'tuxtla' },
  { name: 'Raurkela', slug: 'raurkela' },
  { name: 'Warri', slug: 'warri' },
  { name: 'Guli', slug: 'guli' },
  { name: 'Ebute Ikorodu', slug: 'ebute-ikorodu' },
  { name: 'Tanggu', slug: 'tanggu' },
  { name: 'Jiangmen', slug: 'jiangmen' },
  { name: 'Cuauhtémoc', slug: 'cuauhtemoc' },
  { name: 'Tucson', slug: 'tucson' },
  { name: 'Nashville', slug: 'nashville' },
  { name: 'Ta’if', slug: 'taif' },
  { name: 'Beira', slug: 'beira' },
  { name: 'Guntur', slug: 'guntur' },
  { name: 'Touba', slug: 'touba' },
  { name: 'Québec', slug: 'quebec' },
  { name: 'Hamadān', slug: 'hamadan' },
  { name: 'Cangzhou', slug: 'cangzhou' },
  { name: 'San Salvador', slug: 'san-salvador' },
  { name: 'Dehra Dūn', slug: 'dehra-dun' },
  { name: 'Cuiabá', slug: 'cuiaba' },
  { name: 'Petaling Jaya', slug: 'petaling-jaya' },
  { name: 'Macau', slug: 'macau' },
  { name: 'Bhayandar', slug: 'bhayandar' },
  { name: 'Esenler', slug: 'esenler' },
  { name: 'Ryazan’', slug: 'ryazan' },
  { name: 'Fresno', slug: 'fresno' },
  { name: 'Hamilton', slug: 'hamilton' },
  { name: 'Tyumen', slug: 'tyumen' },
  { name: 'Durgapur', slug: 'durgapur' },
  { name: 'Victoria de Durango', slug: 'victoria-de-durango' },
  { name: 'Ajmer', slug: 'ajmer' },
  { name: 'Lisbon', slug: 'lisbon' },
  { name: 'Changde', slug: 'changde' },
  { name: 'Jiaozuo', slug: 'jiaozuo' },
  { name: 'Ulhasnagar', slug: 'ulhasnagar' },
  { name: 'Kolhāpur', slug: 'kolhapur' },
  { name: 'Lipetsk', slug: 'lipetsk' },
  { name: 'Siliguri', slug: 'siliguri' },
  { name: 'Hannover', slug: 'hannover' },
  { name: 'Eskişehir', slug: 'eskisehir' },
  { name: 'Āzādshahr', slug: 'azadshahr' },
  { name: 'Salta', slug: 'salta' },
  { name: 'Penza', slug: 'penza' },
  { name: 'Tembisa', slug: 'tembisa' },
  { name: 'Bilimora', slug: 'bilimora' },
  { name: 'Mykolayiv', slug: 'mykolayiv' },
  { name: 'Aparecida de Goiânia', slug: 'aparecida-de-goiania' },
  { name: 'Puente Alto', slug: 'puente-alto' },
  { name: 'Makati City', slug: 'makati-city' },
  { name: 'Tonghua', slug: 'tonghua' },
  { name: 'Naberezhnyye Chelny', slug: 'naberezhnyye-chelny' },
  { name: 'Leicester', slug: 'leicester' },
  { name: 'Wuhu', slug: 'wuhu' },
  { name: 'Niigata', slug: 'niigata' },
  { name: 'Karol Bāgh', slug: 'karol-bagh' },
  { name: 'Leipzig', slug: 'leipzig' },
  { name: 'Kalininskiy', slug: 'kalininskiy' },
  { name: 'Duisburg', slug: 'duisburg' },
  { name: 'Āsansol', slug: 'asansol' },
  { name: 'Arāk', slug: 'arak' },
  { name: 'Astrakhan', slug: 'astrakhan' },
  { name: 'Zhuhai', slug: 'zhuhai' },
  { name: 'Pohang', slug: 'pohang' },
  { name: 'Nürnberg', slug: 'nurnberg' },
  { name: 'Shashi', slug: 'shashi' },
  { name: 'Makhachkala', slug: 'makhachkala' },
  { name: 'Cimahi', slug: 'cimahi' },
  { name: 'Wuwei', slug: 'wuwei' },
  { name: 'Jamnagar', slug: 'jamnagar' },
  { name: 'Sacramento', slug: 'sacramento' },
  { name: 'Aracaju', slug: 'aracaju' },
  { name: 'Ajman City', slug: 'ajman-city' },
  { name: 'Jianshui', slug: 'jianshui' },
  { name: 'Port Sudan', slug: 'port-sudan' },
  { name: 'Santa Fe', slug: 'santa-fe' },
  { name: 'San Pedro Sula', slug: 'san-pedro-sula' },
  { name: 'Toluca', slug: 'toluca' },
  { name: 'Ciudad López Mateos', slug: 'ciudad-lopez-mateos' },
  { name: 'Suez', slug: 'suez' },
  { name: 'Dresden', slug: 'dresden' },
  { name: 'Tomsk', slug: 'tomsk' },
  { name: 'Masina', slug: 'masina' },
  { name: 'Sahāranpur', slug: 'saharanpur' },
  { name: 'Cuautitlán Izcalli', slug: 'cuautitlan-izcalli' },
  { name: 'Gulbarga', slug: 'gulbarga' },
  { name: 'Bhātpāra', slug: 'bhatpara' },
  { name: 'Najaf', slug: 'najaf' },
  { name: 'Feira de Santana', slug: 'feira-de-santana' },
  { name: 'Shah Alam', slug: 'shah-alam' },
  { name: 'Mariupol', slug: 'mariupol' },
  { name: 'Himeji', slug: 'himeji' },
  { name: 'Homyel\'', slug: 'homyel' },
  { name: 'Qionghai', slug: 'qionghai' },
  { name: 'Okene', slug: 'okene' },
  { name: 'Uijeongbu-si', slug: 'uijeongbu-si' },
  { name: 'East London', slug: 'east-london' },
  { name: 'Yazd', slug: 'yazd' },
  { name: 'Hargeysa', slug: 'hargeysa' },
  { name: 'Sialkot', slug: 'sialkot' },
  { name: 'Kemerovo', slug: 'kemerovo' },
  { name: 'Yichang', slug: 'yichang' },
  { name: 'Hwaseong-si', slug: 'hwaseong-si' },
  { name: 'Kansas City', slug: 'kansas-city' },
  { name: 'Yinchuan', slug: 'yinchuan' },
  { name: 'Skopje', slug: 'skopje' },
  { name: 'Vereeniging', slug: 'vereeniging' },
  { name: 'The Hague', slug: 'the-hague' },
  { name: 'Long Beach', slug: 'long-beach' },
  { name: 'Mixco', slug: 'mixco' },
  { name: 'Lyon', slug: 'lyon' },
  { name: 'Londrina', slug: 'londrina' },
  { name: 'Mesa', slug: 'mesa' },
  { name: 'Jiaojiang', slug: 'jiaojiang' },
  { name: 'Matsudo', slug: 'matsudo' },
  { name: 'Juiz de Fora', slug: 'juiz-de-fora' },
  { name: 'Nishinomiya-hama', slug: 'nishinomiya-hama' },
  { name: 'Tula', slug: 'tula' },
  { name: 'Staten Island', slug: 'staten-island' },
  { name: 'Kawaguchi', slug: 'kawaguchi' },
  { name: 'Ciudad Apodaca', slug: 'ciudad-apodaca' },
  { name: 'Zunyi', slug: 'zunyi' },
  { name: 'Jiaxing', slug: 'jiaxing' },
  { name: 'Belford Roxo', slug: 'belford-roxo' },
  { name: 'Jammu', slug: 'jammu' },
  { name: 'Liaoyuan', slug: 'liaoyuan' },
  { name: 'Edinburgh', slug: 'edinburgh' },
  { name: 'Atlanta', slug: 'atlanta' },
  { name: 'Kananga', slug: 'kananga' },
  { name: 'Bloemfontein', slug: 'bloemfontein' },
  { name: 'Xiangyang', slug: 'xiangyang' },
  { name: 'Gdańsk', slug: 'gdansk' },
  { name: 'Calabar', slug: 'calabar' },
  { name: 'Dadukou', slug: 'dadukou' },
  { name: 'Joinville', slug: 'joinville' },
  { name: 'Ḩamāh', slug: 'hamah' },
  { name: 'Kurnool', slug: 'kurnool' },
  { name: 'Antwerpen', slug: 'antwerpen' },
  { name: 'Kanazawa', slug: 'kanazawa' },
  { name: 'Karabağlar', slug: 'karabaglar' },
  { name: 'Zamboanga', slug: 'zamboanga' },
  { name: 'Kirov', slug: 'kirov' },
  { name: 'Ujjain', slug: 'ujjain' },
  { name: 'Kota Kinabalu', slug: 'kota-kinabalu' },
  { name: 'Colorado Springs', slug: 'colorado-springs' },
  { name: 'Niterói', slug: 'niteroi' },
  { name: 'Hengshui', slug: 'hengshui' },
  { name: 'Tabuk', slug: 'tabuk' },
  { name: 'Pontianak', slug: 'pontianak' },
  { name: 'Leeds', slug: 'leeds' },
  { name: 'Namp’o', slug: 'nampo' },
  { name: 'Bacolod City', slug: 'bacolod-city' },
  { name: 'São João de Meriti', slug: 'sao-joao-de-meriti' },
  { name: 'Mansilingan', slug: 'mansilingan' },
  { name: 'Virginia Beach', slug: 'virginia-beach' },
  { name: 'Rāmgundam', slug: 'ramgundam' },
  { name: 'Luhansk', slug: 'luhansk' },
  { name: 'Manado', slug: 'manado' },
  { name: 'Karagandy', slug: 'karagandy' },
  { name: 'Raleigh', slug: 'raleigh' },
  { name: 'Jining', slug: 'jining' },
  { name: 'Constantine', slug: 'constantine' },
  { name: 'Wenshan City', slug: 'wenshan-city' },
  { name: 'Juba', slug: 'juba' },
  { name: 'Muratpaşa', slug: 'muratpasa' },
  { name: 'Utsunomiya', slug: 'utsunomiya' },
  { name: 'Heroica Matamoros', slug: 'heroica-matamoros' },
  { name: 'Şanlıurfa', slug: 'sanlurfa' },
  { name: 'Chengde', slug: 'chengde' },
  { name: 'Ōita', slug: 'oita' },
  { name: 'Cardiff', slug: 'cardiff' },
  { name: 'San Juan', slug: 'san-juan' },
  { name: 'Cheboksary', slug: 'cheboksary' },
  { name: 'Boksburg', slug: 'boksburg' },
  { name: 'Cagayan de Oro', slug: 'cagayan-de-oro' },
  { name: 'Omaha', slug: 'omaha' },
  { name: 'Matsuyama', slug: 'matsuyama' },
  { name: 'San Nicolás de los Garza', slug: 'san-nicolas-de-los-garza' },
  { name: 'Amagasaki', slug: 'amagasaki' },
  { name: 'Carrefour', slug: 'carrefour' },
  { name: 'Shyamnagar', slug: 'shyamnagar' },
  { name: 'Dasmariñas', slug: 'dasmarinas' },
  { name: 'Malatya', slug: 'malatya' },
  { name: 'Miami', slug: 'miami' },
  { name: 'Nangi', slug: 'nangi' },
  { name: 'Pereira', slug: 'pereira' },
  { name: 'Kozhikode', slug: 'kozhikode' },
  { name: 'Mawlamyine', slug: 'mawlamyine' },
  { name: 'Iquitos', slug: 'iquitos' },
  { name: 'Kurashiki', slug: 'kurashiki' },
  { name: 'Sunch’ŏn', slug: 'sunchon' },
  { name: 'Sultangazi', slug: 'sultangazi' },
  { name: 'Garoua', slug: 'garoua' },
  { name: 'Murcia', slug: 'murcia' },
  { name: 'Mwanza', slug: 'mwanza' },
  { name: 'Uyo', slug: 'uyo' },
  { name: 'Bei’an', slug: 'beian' },
  { name: 'Kousséri', slug: 'kousseri' },
  { name: 'Mālegaon', slug: 'malegaon' },
  { name: 'Davangere', slug: 'davangere' },
  { name: 'Kaliningrad', slug: 'kaliningrad' },
  { name: 'Karbala', slug: 'karbala' },
  { name: 'Masan', slug: 'masan' },
  { name: 'Ananindeua', slug: 'ananindeua' },
  { name: 'Balikpapan', slug: 'balikpapan' },
  { name: 'Brampton', slug: 'brampton' },
  { name: 'Toulouse', slug: 'toulouse' },
  { name: 'Tel Aviv', slug: 'tel-aviv' },
  { name: 'Namangan', slug: 'namangan' },
  { name: 'Katsina', slug: 'katsina' },
  { name: 'Welkom', slug: 'welkom' },
  { name: 'Santa Marta', slug: 'santa-marta' },
  { name: 'Al Maḩallah al Kubrá', slug: 'al-mahallah-al-kubra' },
  { name: 'Venustiano Carranza', slug: 'venustiano-carranza' },
  { name: 'Jalgaon', slug: 'jalgaon' },
  { name: 'Yokosuka', slug: 'yokosuka' },
  { name: 'Akola', slug: 'akola' },
  { name: 'Belgaum', slug: 'belgaum' },
  { name: 'Veracruz', slug: 'veracruz' },
  { name: 'East Jerusalem', slug: 'east-jerusalem' },
  { name: 'Luqiao', slug: 'luqiao' },
  { name: 'Bryansk', slug: 'bryansk' },
  { name: 'Maltepe', slug: 'maltepe' },
  { name: 'Al Kharj', slug: 'al-kharj' },
  { name: 'Chaozhou', slug: 'chaozhou' },
  { name: 'Xalapa de Enríquez', slug: 'xalapa-de-enriquez' },
  { name: 'Ado-Ekiti', slug: 'ado-ekiti' },
  { name: 'Bratislava', slug: 'bratislava' },
  { name: 'Gaya', slug: 'gaya' },
  { name: 'Udaipur', slug: 'udaipur' },
  { name: 'Likasi', slug: 'likasi' },
  { name: 'Luxor', slug: 'luxor' },
  { name: 'Ibagué', slug: 'ibague' },
  { name: 'Shaoxing', slug: 'shaoxing' },
  { name: 'Ivanovo', slug: 'ivanovo' },
  { name: 'Erzurum', slug: 'erzurum' },
  { name: 'Akure', slug: 'akure' },
  { name: 'Asyūţ', slug: 'asyut' },
  { name: 'Jambi City', slug: 'jambi-city' },
  { name: 'Al Manşūrah', slug: 'al-mansurah' },
  { name: 'Oakland', slug: 'oakland' },
  { name: 'Korba', slug: 'korba' },
  { name: 'Bokāro', slug: 'bokaro' },
  { name: 'Kolwezi', slug: 'kolwezi' },
  { name: 'Auckland', slug: 'auckland' },
  { name: 'Sukkur', slug: 'sukkur' },
  { name: 'Mangalore', slug: 'mangalore' },
  { name: 'Luohe', slug: 'luohe' },
  { name: 'Pasay', slug: 'pasay' },
  { name: 'Sevastopol', slug: 'sevastopol' },
  { name: 'Azcapotzalco', slug: 'azcapotzalco' },
  { name: 'Shymkent', slug: 'shymkent' },
  { name: 'Yangquan', slug: 'yangquan' },
  { name: 'Magnitogorsk', slug: 'magnitogorsk' },
  { name: 'Jhānsi', slug: 'jhansi' },
  { name: 'Florianópolis', slug: 'florianopolis' },
  { name: 'Wandsbek', slug: 'wandsbek' },
  { name: 'Santos', slug: 'santos' },
  { name: 'Maturín', slug: 'maturin' },
  { name: 'Minneapolis', slug: 'minneapolis' },
  { name: 'Thoothukudi', slug: 'thoothukudi' },
  { name: 'Ardabīl', slug: 'ardabil' },
  { name: 'Nagasaki', slug: 'nagasaki' },
  { name: 'Chaoyang', slug: 'chaoyang' },
  { name: 'Gaza', slug: 'gaza' },
  { name: 'Kursk', slug: 'kursk' },
  { name: 'Tonalá', slug: 'tonala' },
  { name: 'Jeju City', slug: 'jeju-city' },
  { name: 'Panamá', slug: 'panama' },
  { name: 'Xochimilco', slug: 'xochimilco' },
  { name: 'Szczecin', slug: 'szczecin' },
  { name: 'Biên Hòa', slug: 'bien-hoa' },
  { name: 'Villa Nueva', slug: 'villa-nueva' },
  { name: 'Ribeirão das Neves', slug: 'ribeirao-das-neves' },
  { name: 'Hirakata', slug: 'hirakata' },
  { name: 'Oujda-Angad', slug: 'oujda-angad' },
  { name: 'Tanda', slug: 'tanda' },
  { name: 'Newcastle', slug: 'newcastle' },
  { name: 'Nellore', slug: 'nellore' },
  { name: 'Hsinchu', slug: 'hsinchu' },
  { name: 'Jixi', slug: 'jixi' },
  { name: 'Zanzibar', slug: 'zanzibar' },
  { name: 'Tulsa', slug: 'tulsa' },
  { name: 'Taoyuan City', slug: 'taoyuan-city' },
  { name: 'Kassala', slug: 'kassala' },
  { name: 'Lekki', slug: 'lekki' },
  { name: 'Palma', slug: 'palma' },
  { name: 'Kitwe', slug: 'kitwe' },
  { name: 'Nasiriyah', slug: 'nasiriyah' },
  { name: 'Tver', slug: 'tver' },
  { name: 'West Jerusalem', slug: 'west-jerusalem' },
  { name: 'Machida', slug: 'machida' },
  { name: 'Yangjiang', slug: 'yangjiang' },
  { name: 'Khmelnytskyi', slug: 'khmelnytskyi' },
  { name: 'Gifu-shi', slug: 'gifu-shi' },
  { name: 'Tiruppur', slug: 'tiruppur' },
  { name: 'Keelung', slug: 'keelung' },
  { name: 'Al Hoceïma', slug: 'al-hoceima' },
  { name: 'Manchester', slug: 'manchester' },
  { name: 'Surrey', slug: 'surrey' },
  { name: 'Vila Velha', slug: 'vila-velha' },
  { name: 'Weifang', slug: 'weifang' },
  { name: 'Fujisawa', slug: 'fujisawa' },
  { name: 'Ndola', slug: 'ndola' },
  { name: 'Kollam', slug: 'kollam' },
  { name: 'Serra', slug: 'serra' },
  { name: 'Samsun', slug: 'samsun' },
  { name: 'Tallinn', slug: 'tallinn' },
  { name: 'Bamenda', slug: 'bamenda' },
  { name: 'El Obeid', slug: 'el-obeid' },
  { name: 'Bello', slug: 'bello' },
  { name: 'Xinpu', slug: 'xinpu' },
  { name: 'Sandakan', slug: 'sandakan' },
  { name: 'Buraydah', slug: 'buraydah' },
  { name: 'Kandahār', slug: 'kandahar' },
  { name: 'Diadema', slug: 'diadema' },
  { name: 'Wichita', slug: 'wichita' },
  { name: 'New Orleans', slug: 'new-orleans' },
  { name: 'Comilla', slug: 'comilla' },
  { name: 'Samut Prakan', slug: 'samut-prakan' },
  { name: 'Nampula', slug: 'nampula' },
  { name: 'Arlington', slug: 'arlington' },
  { name: 'Cleveland', slug: 'cleveland' },
  { name: 'Bissau', slug: 'bissau' },
  { name: 'Iloilo', slug: 'iloilo' },
  { name: 'Khamis Mushait', slug: 'khamis-mushait' },
  { name: 'Campos dos Goytacazes', slug: 'campos-dos-goytacazes' },
  { name: 'Resistencia', slug: 'resistencia' },
  { name: 'Mişrātah', slug: 'misratah' },
  { name: 'Mauá', slug: 'maua' },
  { name: 'Abomey-Calavi', slug: 'abomey-calavi' },
  { name: 'Bochum', slug: 'bochum' },
  { name: 'Benito Juárez', slug: 'benito-juarez' },
  { name: 'Sector 3', slug: 'sector-3' },
  { name: 'Toyonaka', slug: 'toyonaka' },
  { name: 'Iztacalco', slug: 'iztacalco' },
  { name: 'Betim', slug: 'betim' },
  { name: 'Fukuyama', slug: 'fukuyama' },
  { name: 'N’dalatando', slug: 'ndalatando' },
  { name: 'Delmas 73', slug: 'delmas-73' },
  { name: 'Pasto', slug: 'pasto' },
  { name: 'Batman', slug: 'batman' },
  { name: 'Wellington', slug: 'wellington' },
  { name: 'Las Palmas de Gran Canaria', slug: 'las-palmas-de-gran-canaria' },
  { name: 'Mazatlán', slug: 'mazatlan' },
  { name: 'Caxias do Sul', slug: 'caxias-do-sul' },
  { name: 'Nizhny Tagil', slug: 'nizhny-tagil' },
  { name: 'Irapuato', slug: 'irapuato' },
  { name: 'Bochum-Hordel', slug: 'bochum-hordel' },
  { name: 'Dezhou', slug: 'dezhou' },
  { name: 'Krugersdorp', slug: 'krugersdorp' },
  { name: 'Pānihāti', slug: 'panihati' },
  { name: 'Shibganj', slug: 'shibganj' },
  { name: 'Toyohashi', slug: 'toyohashi' },
  { name: 'Zhoukou', slug: 'zhoukou' },
  { name: 'Laval', slug: 'laval' },
  { name: 'Huancayo', slug: 'huancayo' },
  { name: 'Makiyivka', slug: 'makiyivka' },
  { name: 'Putian', slug: 'putian' },
  { name: 'Kahramanmaraş', slug: 'kahramanmaras' },
  { name: 'Minato', slug: 'minato' },
  { name: 'Tirana', slug: 'tirana' },
  { name: 'São José do Rio Preto', slug: 'sao-jose-do-rio-preto' },
  { name: 'Kaunas', slug: 'kaunas' },
  { name: 'Nuevo Laredo', slug: 'nuevo-laredo' },
  { name: 'Bakersfield', slug: 'bakersfield' },
  { name: 'Zhangjiakou Shi Xuanhua Qu', slug: 'zhangjiakou-shi-xuanhua-qu' },
  { name: 'Seremban', slug: 'seremban' },
  { name: 'Miguel Hidalgo', slug: 'miguel-hidalgo' },
  { name: 'Stoke-on-Trent', slug: 'stoke-on-trent' },
  { name: 'Pingxiang', slug: 'pingxiang' },
  { name: 'Van', slug: 'van' },
  { name: 'Honolulu', slug: 'honolulu' },
  { name: 'Abadan', slug: 'abadan' },
  { name: 'Fenghuang', slug: 'fenghuang' },
  { name: 'Puerto La Cruz', slug: 'puerto-la-cruz' },
  { name: 'Brno', slug: 'brno' },
  { name: 'Mahilyow', slug: 'mahilyow' },
  { name: 'Natore', slug: 'natore' },
  { name: 'Tampa', slug: 'tampa' },
  { name: 'Sector 6', slug: 'sector-6' },
  { name: 'Canberra', slug: 'canberra' },
  { name: 'Nara-shi', slug: 'nara-shi' },
  { name: 'Ahmadnagar', slug: 'ahmadnagar' },
  { name: 'Dhūlia', slug: 'dhulia' },
  { name: 'Olinda', slug: 'olinda' },
  { name: 'Kenitra', slug: 'kenitra' },
  { name: 'Bydgoszcz', slug: 'bydgoszcz' },
  { name: 'Kuantan', slug: 'kuantan' },
  { name: 'Bologna', slug: 'bologna' },
  { name: 'Cheonan', slug: 'cheonan' },
  { name: 'Petare', slug: 'petare' },
  { name: 'Larkana', slug: 'larkana' },
  { name: 'Al Qadarif', slug: 'al-qadarif' },
  { name: 'Christchurch', slug: 'christchurch' },
  { name: 'Stavropol’', slug: 'stavropol' },
  { name: 'Toyota', slug: 'toyota' },
  { name: 'Manukau City', slug: 'manukau-city' },
  { name: 'Zhaoqing', slug: 'zhaoqing' },
  { name: 'Ataşehir', slug: 'atasehir' },
  { name: 'Bhāgalpur', slug: 'bhagalpur' },
  { name: 'Shekhupura', slug: 'shekhupura' },
  { name: 'Carapicuíba', slug: 'carapicuiba' },
  { name: 'Wuppertal', slug: 'wuppertal' },
  { name: 'Tamale', slug: 'tamale' },
  { name: 'Ulan-Ude', slug: 'ulan-ude' },
  { name: 'Nagano', slug: 'nagano' },
  { name: 'Bobo-Dioulasso', slug: 'bobo-dioulasso' },
  { name: 'Lublin', slug: 'lublin' },
  { name: 'Huocheng', slug: 'huocheng' },
  { name: 'Aurora', slug: 'aurora' },
  { name: 'Coventry', slug: 'coventry' },
  { name: 'Halifax', slug: 'halifax' },
  { name: 'Anqing', slug: 'anqing' },
  { name: 'Taraz', slug: 'taraz' },
  { name: 'San Jose del Monte', slug: 'san-jose-del-monte' },
  { name: 'Manizales', slug: 'manizales' },
  { name: 'Kwangmyŏng', slug: 'kwangmyong' },
  { name: 'Zanjān', slug: 'zanjan' },
  { name: 'Iwaki', slug: 'iwaki' },
  { name: 'Bacoor', slug: 'bacoor' },
  { name: 'Asahikawa', slug: 'asahikawa' },
  { name: 'Xico', slug: 'xico' },
  { name: 'Kimhae', slug: 'kimhae' },
  { name: 'Arkhangel’sk', slug: 'arkhangelsk' },
  { name: 'Ambon', slug: 'ambon' },
  { name: 'Samarinda', slug: 'samarinda' },
  { name: 'Bilbao', slug: 'bilbao' },
  { name: 'Santiago del Estero', slug: 'santiago-del-estero' },
  { name: 'Takatsuki', slug: 'takatsuki' },
  { name: 'Thessaloníki', slug: 'thessaloniki' },
  { name: 'Villahermosa', slug: 'villahermosa' },
  { name: 'Barinas', slug: 'barinas' },
  { name: 'Neiva', slug: 'neiva' },
  { name: 'Ciudad General Escobedo', slug: 'ciudad-general-escobedo' },
  { name: 'Okazaki', slug: 'okazaki' },
  { name: 'Bandar Abbas', slug: 'bandar-abbas' },
  { name: 'Vinnytsia', slug: 'vinnytsia' },
  { name: 'Ras Al Khaimah City', slug: 'ras-al-khaimah-city' },
  { name: 'Anshun', slug: 'anshun' },
  { name: 'Suita', slug: 'suita' },
  { name: 'Wakayama', slug: 'wakayama' },
  { name: 'Anaheim', slug: 'anaheim' },
  { name: 'Hualien City', slug: 'hualien-city' },
  { name: 'Lapu-Lapu City', slug: 'lapu-lapu-city' },
  { name: 'Punāsa', slug: 'punasa' },
  { name: 'Diepsloot', slug: 'diepsloot' },
  { name: 'Muzaffarnagar', slug: 'muzaffarnagar' },
  { name: 'Florence', slug: 'florence' },
  { name: 'Sanandaj', slug: 'sanandaj' },
  { name: 'Latur', slug: 'latur' },
  { name: 'Campina Grande', slug: 'campina-grande' },
  { name: 'Etobicoke', slug: 'etobicoke' },
  { name: 'Camagüey', slug: 'camaguey' },
  { name: 'Chifeng', slug: 'chifeng' },
  { name: 'Hŭngnam', slug: 'hungnam' },
  { name: 'Nur-Sultan', slug: 'nur-sultan' },
  { name: 'Sector 2', slug: 'sector-2' },
  { name: 'Belgorod', slug: 'belgorod' },
  { name: 'Kosti', slug: 'kosti' },
  { name: 'Taihecun', slug: 'taihecun' },
  { name: 'Doha', slug: 'doha' },
  { name: 'Turmero', slug: 'turmero' },
  { name: 'Kurgan', slug: 'kurgan' },
  { name: 'Rangpur', slug: 'rangpur' },
  { name: 'Bhimbar', slug: 'bhimbar' },
  { name: 'Vitebsk', slug: 'vitebsk' },
  { name: 'Iligan', slug: 'iligan' },
  { name: 'Soledad', slug: 'soledad' },
  { name: 'Shiqi', slug: 'shiqi' },
  { name: 'Piracicaba', slug: 'piracicaba' },
  { name: 'Zürich', slug: 'zurich' },
  { name: 'Kūkatpalli', slug: 'kukatpalli' },
  { name: 'Jhang Sadr', slug: 'jhang-sadr' },
  { name: 'Arusha', slug: 'arusha' },
  { name: 'Ambattūr', slug: 'ambattur' },
  { name: 'Kōriyama', slug: 'koriyama' },
  { name: 'Plovdiv', slug: 'plovdiv' },
  { name: 'Celaya', slug: 'celaya' },
  { name: 'Chitungwiza', slug: 'chitungwiza' },
  { name: 'Kashiwa', slug: 'kashiwa' },
  { name: 'Latakia', slug: 'latakia' },
  { name: 'Aksu', slug: 'aksu' },
  { name: 'Serekunda', slug: 'serekunda' },
  { name: 'Tokorozawa', slug: 'tokorozawa' },
  { name: 'Corrientes', slug: 'corrientes' },
  { name: 'Kaluga', slug: 'kaluga' },
  { name: 'Macapá', slug: 'macapa' },
  { name: 'West Raleigh', slug: 'west-raleigh' },
  { name: 'Cuernavaca', slug: 'cuernavaca' },
  { name: 'Nice', slug: 'nice' },
  { name: 'Kaesŏng', slug: 'kaesong' },
  { name: 'Ciudad Bolívar', slug: 'ciudad-bolivar' },
  { name: 'Kawagoe', slug: 'kawagoe' },
  { name: 'Tungi', slug: 'tungi' },
  { name: 'Krasnogvargeisky', slug: 'krasnogvargeisky' },
  { name: 'Randburg', slug: 'randburg' },
  { name: 'Bellary', slug: 'bellary' },
  { name: 'Itaquaquecetuba', slug: 'itaquaquecetuba' },
  { name: 'Simferopol', slug: 'simferopol' },
  { name: 'Sunderland', slug: 'sunderland' },
  { name: 'Santa Ana', slug: 'santa-ana' },
  { name: 'Bauru', slug: 'bauru' },
  { name: 'Alicante', slug: 'alicante' },
  { name: 'Takamatsu', slug: 'takamatsu' },
  { name: 'Tieling', slug: 'tieling' },
  { name: 'Qazvin', slug: 'qazvin' },
  { name: 'Muzaffarpur', slug: 'muzaffarpur' },
  { name: 'Kāmārhāti', slug: 'kamarhati' },
  { name: 'Tepic', slug: 'tepic' },
  { name: 'Wad Medani', slug: 'wad-medani' },
  { name: 'Jincheng', slug: 'jincheng' },
  { name: 'Montes Claros', slug: 'montes-claros' },
  { name: 'Bielefeld', slug: 'bielefeld' },
  { name: 'Bujumbura', slug: 'bujumbura' },
  { name: 'Mandaue City', slug: 'mandaue-city' },
  { name: 'Khorramshahr', slug: 'khorramshahr' },
  { name: 'Mathura', slug: 'mathura' },
  { name: 'Khorramabad', slug: 'khorramabad' },
  { name: 'Soyapango', slug: 'soyapango' },
  { name: 'Patiāla', slug: 'patiala' },
  { name: 'Wŏnsan', slug: 'wonsan' },
  { name: 'Brent', slug: 'brent' },
  { name: 'Pavlodar', slug: 'pavlodar' },
  { name: 'Chānda', slug: 'chanda' },
  { name: 'Canoas', slug: 'canoas' },
  { name: 'Sochi', slug: 'sochi' },
  { name: 'Chongjin', slug: 'chongjin' },
  { name: 'Yanji', slug: 'yanji' },
  { name: 'Bhīlwāra', slug: 'bhilwara' },
  { name: 'Tétouan', slug: 'tetouan' },
  { name: 'Mogi das Cruzes', slug: 'mogi-das-cruzes' },
  { name: 'Toyama', slug: 'toyama' },
  { name: 'Piura', slug: 'piura' },
  { name: 'Birkenhead', slug: 'birkenhead' },
  { name: 'Thrissur', slug: 'thrissur' },
  { name: 'Brahmapur', slug: 'brahmapur' },
  { name: 'São Vicente', slug: 'sao-vicente' },
  { name: 'Orël', slug: 'orel' },
  { name: 'Corpus Christi', slug: 'corpus-christi' },
  { name: 'Suizhou', slug: 'suizhou' },
  { name: 'Posadas', slug: 'posadas' },
  { name: 'Al ‘Amārah', slug: 'al-amarah' },
  { name: 'Volzhskiy', slug: 'volzhskiy' },
  { name: 'Riverside', slug: 'riverside' },
  { name: 'Ixtapaluca', slug: 'ixtapaluca' },
  { name: 'Villavicencio', slug: 'villavicencio' },
  { name: 'Jundiaí', slug: 'jundiai' },
  { name: 'San Miguelito', slug: 'san-miguelito' },
  { name: 'Smolensk', slug: 'smolensk' },
  { name: 'Ciudad del Este', slug: 'ciudad-del-este' },
  { name: 'Pelotas', slug: 'pelotas' },
  { name: 'Kherson', slug: 'kherson' },
  { name: 'Shāhjānpur', slug: 'shahjanpur' },
  { name: 'Akita', slug: 'akita' },
  { name: 'Thiès', slug: 'thies' },
  { name: 'Maroua', slug: 'maroua' },
  { name: 'Morón', slug: 'moron' },
  { name: 'Anápolis', slug: 'anapolis' },
  { name: 'Shimoga', slug: 'shimoga' },
  { name: 'Samarkand', slug: 'samarkand' },
  { name: 'Murmansk', slug: 'murmansk' },
  { name: 'Islington', slug: 'islington' },
  { name: 'Holguín', slug: 'holguin' },
  { name: 'Ust-Kamenogorsk', slug: 'ust-kamenogorsk' },
  { name: 'Ad Dīwānīyah', slug: 'ad-diwaniyah' },
  { name: 'Shangrao', slug: 'shangrao' },
  { name: 'Mataram', slug: 'mataram' },
  { name: 'Andijon', slug: 'andijon' },
  { name: 'Reading', slug: 'reading' },
  { name: 'Iaşi', slug: 'iasi' },
  { name: 'Valladolid', slug: 'valladolid' },
  { name: 'Poltava', slug: 'poltava' },
  { name: 'New Delhi', slug: 'new-delhi' },
  { name: 'Koshigaya', slug: 'koshigaya' },
  { name: 'Vladikavkaz', slug: 'vladikavkaz' },
  { name: 'Hrodna', slug: 'hrodna' },
  { name: 'Katowice', slug: 'katowice' },
  { name: 'Rohtak', slug: 'rohtak' },
  { name: 'Baicheng', slug: 'baicheng' },
  { name: 'Chimbote', slug: 'chimbote' },
  { name: 'Cluj-Napoca', slug: 'cluj-napoca' },
  { name: 'Calamba', slug: 'calamba' },
  { name: 'Bauchi', slug: 'bauchi' },
  { name: 'Cherepovets', slug: 'cherepovets' },
  { name: 'St. Louis', slug: 'st-louis' },
  { name: 'Armenia', slug: 'armenia' },
  { name: 'Al Kūt', slug: 'al-kut' },
  { name: 'Timişoara', slug: 'timisoara' },
  { name: 'Vologda', slug: 'vologda' },
  { name: 'Şişli', slug: 'sisli' },
  { name: 'Lexington-Fayette', slug: 'lexington-fayette' },
  { name: 'Kingston upon Hull', slug: 'kingston-upon-hull' },
  { name: 'Soacha', slug: 'soacha' },
  { name: 'Temara', slug: 'temara' },
  { name: 'Preston', slug: 'preston' },
  { name: 'Ganja', slug: 'ganja' },
  { name: 'Lianshan', slug: 'lianshan' },
  { name: 'Denizli', slug: 'denizli' },
  { name: 'Ikeja', slug: 'ikeja' },
  { name: 'Bonn', slug: 'bonn' },
  { name: 'Ostrava', slug: 'ostrava' },
  { name: 'Varna', slug: 'varna' },
  { name: 'Vitória', slug: 'vitoria' },
  { name: 'Wusong', slug: 'wusong' },
  { name: 'Iligan City', slug: 'iligan-city' },
  { name: 'Cusco', slug: 'cusco' },
  { name: 'Maringá', slug: 'maringa' },
  { name: 'Miyazaki', slug: 'miyazaki' },
  { name: 'Percut', slug: 'percut' },
  { name: 'Pucallpa', slug: 'pucallpa' },
  { name: 'Jingdezhen', slug: 'jingdezhen' },
  { name: 'Guarujá', slug: 'guaruja' },
  { name: 'Sariwŏn', slug: 'sariwon' },
  { name: 'Vladimir', slug: 'vladimir' },
  { name: 'Antofagasta', slug: 'antofagasta' },
  { name: 'Botshabelo', slug: 'botshabelo' },
  { name: 'Bengkulu', slug: 'bengkulu' },
  { name: 'Butuan', slug: 'butuan' },
  { name: 'Tampico', slug: 'tampico' },
  { name: 'Oshawa', slug: 'oshawa' },
  { name: 'Cabuyao', slug: 'cabuyao' },
  { name: 'Chita', slug: 'chita' },
  { name: 'Valledupar', slug: 'valledupar' },
  { name: 'Biskra', slug: 'biskra' },
  { name: 'Mannheim', slug: 'mannheim' },
  { name: 'Chernihiv', slug: 'chernihiv' },
  { name: 'Irbid', slug: 'irbid' },
  { name: 'Tumkūr', slug: 'tumkur' },
  { name: 'Chinju', slug: 'chinju' },
  { name: 'Newport', slug: 'newport' },
  { name: 'Tawau', slug: 'tawau' },
  { name: 'Shengli', slug: 'shengli' },
  { name: 'Fīrozābād', slug: 'firozabad' },
  { name: 'Al Fayyūm', slug: 'al-fayyum' },
  { name: 'Porto Velho', slug: 'porto-velho' },
  { name: 'San Salvador de Jujuy', slug: 'san-salvador-de-jujuy' },
  { name: 'Brakpan', slug: 'brakpan' },
  { name: 'Stockton', slug: 'stockton' },
  { name: 'Mandaluyong City', slug: 'mandaluyong-city' },
  { name: 'Nizāmābād', slug: 'nizamabad' },
  { name: 'Kulti', slug: 'kulti' },
  { name: 'Ciudad Victoria', slug: 'ciudad-victoria' },
  { name: 'Tláhuac', slug: 'tlahuac' },
  { name: 'Franca', slug: 'franca' },
  { name: 'Rājahmundry', slug: 'rajahmundry' },
  { name: 'Pittsburgh', slug: 'pittsburgh' },
  { name: 'Craiova', slug: 'craiova' },
  { name: 'Constanţa', slug: 'constanta' },
  { name: 'Saransk', slug: 'saransk' },
  { name: 'Mazār-e Sharīf', slug: 'mazar-e-sharif' },
  { name: 'Barddhamān', slug: 'barddhaman' },
  { name: 'Malmö', slug: 'malmo' },
  { name: 'Gujrat', slug: 'gujrat' },
  { name: 'Naha', slug: 'naha' },
  { name: 'Brest', slug: 'brest' },
  { name: 'Mardan', slug: 'mardan' },
  { name: 'Surgut', slug: 'surgut' },
  { name: 'Swansea', slug: 'swansea' },
  { name: 'Xinyuan', slug: 'xinyuan' },
  { name: 'Yangshuo', slug: 'yangshuo' },
  { name: 'Kyzylorda', slug: 'kyzylorda' },
  { name: 'George Town', slug: 'george-town' },
  { name: 'Biñan', slug: 'binan' },
  { name: 'Malir Cantonment', slug: 'malir-cantonment' },
  { name: 'Winejok', slug: 'winejok' },
  { name: 'Batikent', slug: 'batikent' },
  { name: 'Angeles City', slug: 'angeles-city' },
  { name: 'Bradford', slug: 'bradford' },
  { name: 'Santol', slug: 'santol' },
  { name: 'Anchorage', slug: 'anchorage' },
  { name: 'Ciudad Obregón', slug: 'ciudad-obregon' },
  { name: 'Kasugai', slug: 'kasugai' },
  { name: 'Jember', slug: 'jember' },
  { name: 'Aomori', slug: 'aomori' },
  { name: 'Ōtsu', slug: 'otsu' },
  { name: 'Bārāsat', slug: 'barasat' },
  { name: 'Elazığ', slug: 'elazg' },
  { name: 'Okanagan', slug: 'okanagan' },
  { name: 'Cherkasy', slug: 'cherkasy' },
  { name: 'Vigo', slug: 'vigo' },
  { name: 'Akashi', slug: 'akashi' },
  { name: 'Bāli', slug: 'bali' },
  { name: 'Cincinnati', slug: 'cincinnati' },
  { name: 'Hisar', slug: 'hisar' },
  { name: 'Rāmpur', slug: 'rampur' },
  { name: 'Yokkaichi', slug: 'yokkaichi' },
  { name: 'Yeosu', slug: 'yeosu' },
  { name: 'Southend-on-Sea', slug: 'southend-on-sea' },
  { name: 'Morioka', slug: 'morioka' },
  { name: 'Viña del Mar', slug: 'vina-del-mar' },
  { name: 'Sumy', slug: 'sumy' },
  { name: 'Fukushima', slug: 'fukushima' },
  { name: 'Galaţi', slug: 'galati' },
  { name: 'Blumenau', slug: 'blumenau' },
  { name: 'Greater Noida', slug: 'greater-noida' },
  { name: 'Foz do Iguaçu', slug: 'foz-do-iguacu' },
  { name: 'Al Hufūf', slug: 'al-hufuf' },
  { name: 'Kākināda', slug: 'kakinada' },
  { name: 'Pānīpat', slug: 'panipat' },
  { name: 'Semey', slug: 'semey' },
  { name: 'Makurdi', slug: 'makurdi' },
  { name: 'Wollongong', slug: 'wollongong' },
  { name: 'Ponta Grossa', slug: 'ponta-grossa' },
  { name: 'Minna', slug: 'minna' },
  { name: 'Białystok', slug: 'biaystok' },
  { name: 'Mbeya', slug: 'mbeya' },
  { name: 'Mueang Nonthaburi', slug: 'mueang-nonthaburi' },
  { name: 'Gumi', slug: 'gumi' },
  { name: 'Tambov', slug: 'tambov' },
  { name: 'Catania', slug: 'catania' },
  { name: 'Al Mubarraz', slug: 'al-mubarraz' },
  { name: 'Bafoussam', slug: 'bafoussam' },
  { name: 'Kasur', slug: 'kasur' },
  { name: 'Utrecht', slug: 'utrecht' },
  { name: 'Xiuying', slug: 'xiuying' },
  { name: 'Paulista', slug: 'paulista' },
  { name: 'Al Ḩillah', slug: 'al-hillah' },
  { name: 'Limeira', slug: 'limeira' },
  { name: 'Parbhani', slug: 'parbhani' },
  { name: 'Victoria', slug: 'victoria' },
  { name: 'Beihai', slug: 'beihai' },
  { name: 'Huizhou', slug: 'huizhou' },
  { name: 'Zeytinburnu', slug: 'zeytinburnu' },
  { name: 'Tsuen Wan', slug: 'tsuen-wan' },
  { name: 'Ironville', slug: 'ironville' },
  { name: 'Meads', slug: 'meads' },
  { name: 'Sétif', slug: 'setif' },
  { name: 'Safi', slug: 'safi' },
  { name: 'Sinŭiju', slug: 'sinuiju' },
  { name: 'Sector 4', slug: 'sector-4' },
  { name: 'Huế', slug: 'hue' },
  { name: 'Darbhanga', slug: 'darbhanga' },
  { name: 'Marienthal', slug: 'marienthal' },
  { name: 'Adapazarı', slug: 'adapazar' },
  { name: 'Sultanbeyli', slug: 'sultanbeyli' },
  { name: 'Henderson', slug: 'henderson' },
  { name: 'Greensboro', slug: 'greensboro' },
  { name: 'Viamão', slug: 'viamao' },
  { name: 'Zagazig', slug: 'zagazig' },
  { name: 'Saint Paul', slug: 'saint-paul' },
  { name: 'Kuala Terengganu', slug: 'kuala-terengganu' },
  { name: 'Ismailia', slug: 'ismailia' },
  { name: 'Alto Barinas', slug: 'alto-barinas' },
  { name: 'Dihok', slug: 'dihok' },
  { name: 'Karlsruhe', slug: 'karlsruhe' },
  { name: 'Port Moresby', slug: 'port-moresby' },
  { name: 'Plano', slug: 'plano' },
  { name: 'Ichihara', slug: 'ichihara' },
  { name: 'Iksan', slug: 'iksan' },
  { name: 'Nha Trang', slug: 'nha-trang' },
  { name: 'Suzano', slug: 'suzano' },
  { name: 'Alwar', slug: 'alwar' },
  { name: 'Cainta', slug: 'cainta' },
  { name: 'Pétionville', slug: 'petionville' },
  { name: 'Maebashi', slug: 'maebashi' },
  { name: 'Bilāspur', slug: 'bilaspur' },
  { name: 'Logan City', slug: 'logan-city' },
  { name: 'Valparaíso', slug: 'valparaiso' },
  { name: 'Palu', slug: 'palu' },
  { name: 'Kupang', slug: 'kupang' },
  { name: 'Zhytomyr', slug: 'zhytomyr' },
  { name: 'Newark', slug: 'newark' },
  { name: 'Itagüí', slug: 'itagui' },
  { name: 'Nicolás Romero', slug: 'nicolas-romero' },
  { name: 'Gebze', slug: 'gebze' },
  { name: 'Narsingdi', slug: 'narsingdi' },
  { name: 'Batna', slug: 'batna' },
  { name: 'Chuzhou', slug: 'chuzhou' },
  { name: 'Merkezefendi', slug: 'merkezefendi' },
  { name: 'Ichinomiya', slug: 'ichinomiya' },
  { name: 'Tacna', slug: 'tacna' },
  { name: 'Hamburg-Nord', slug: 'hamburg-nord' },
  { name: 'Mingora', slug: 'mingora' },
  { name: 'Toledo', slug: 'toledo' },
  { name: 'Ensenada', slug: 'ensenada' },
  { name: 'Efon-Alaaye', slug: 'efon-alaaye' },
  { name: 'Yoshkar-Ola', slug: 'yoshkar-ola' },
  { name: 'Taganrog', slug: 'taganrog' },
  { name: 'Santa Teresa del Tuy', slug: 'santa-teresa-del-tuy' },
  { name: 'Horlivka', slug: 'horlivka' },
  { name: 'Windsor', slug: 'windsor' },
  { name: 'Coacalco', slug: 'coacalco' },
  { name: 'Ilesa', slug: 'ilesa' },
  { name: 'Kostroma', slug: 'kostroma' },
  { name: 'Gijón', slug: 'gijon' },
  { name: 'Bari', slug: 'bari' },
  { name: 'Lincoln', slug: 'lincoln' },
  { name: 'Khomeynī Shahr', slug: 'khomeyni-shahr' },
  { name: 'Sfax', slug: 'sfax' },
  { name: 'Nantes', slug: 'nantes' },
  { name: 'Cuenca', slug: 'cuenca' },
  { name: 'Owo', slug: 'owo' },
  { name: 'Bahía Blanca', slug: 'bahia-blanca' },
  { name: 'Sukabumi', slug: 'sukabumi' },
  { name: 'Braşov', slug: 'brasov' },
  { name: 'Komsomolsk-on-Amur', slug: 'komsomolsk-on-amur' },
  { name: 'Hakodate', slug: 'hakodate' },
  { name: 'Bab Ezzouar', slug: 'bab-ezzouar' },
  { name: 'Mokolo', slug: 'mokolo' },
  { name: 'Caucaia', slug: 'caucaia' },
  { name: 'Strasbourg', slug: 'strasbourg' },
  { name: 'Belfast', slug: 'belfast' },
  { name: 'Kashgar', slug: 'kashgar' },
  { name: 'Ramadi', slug: 'ramadi' },
  { name: 'Ichalkaranji', slug: 'ichalkaranji' },
  { name: 'Ibaraki', slug: 'ibaraki' },
  { name: 'Yao', slug: 'yao' },
  { name: 'Herāt', slug: 'herat' },
  { name: 'Guantánamo', slug: 'guantanamo' },
  { name: 'Nal’chik', slug: 'nalchik' },
  { name: 'Baguio', slug: 'baguio' },
  { name: 'Petrópolis', slug: 'petropolis' },
  { name: 'Ar Rayyān', slug: 'ar-rayyan' },
  { name: 'Wiesbaden', slug: 'wiesbaden' },
  { name: 'Montería', slug: 'monteria' },
  { name: 'Ljubljana', slug: 'ljubljana' },
  { name: 'Hafar Al-Batin', slug: 'hafar-al-batin' },
  { name: 'Kakogawachō-honmachi', slug: 'kakogawacho-honmachi' },
  { name: 'Sector 5', slug: 'sector-5' },
  { name: 'Tasikmalaya', slug: 'tasikmalaya' },
  { name: 'Bijapur', slug: 'bijapur' },
  { name: 'Orlando', slug: 'orlando' },
  { name: 'Linyi', slug: 'linyi' },
  { name: 'Derby', slug: 'derby' },
  { name: 'San Pedro', slug: 'san-pedro' },
  { name: 'Münster', slug: 'munster' },
  { name: 'Gelsenkirchen', slug: 'gelsenkirchen' },
  { name: 'Mokpo', slug: 'mokpo' },
  { name: 'Santa Catarina', slug: 'santa-catarina' },
  { name: 'Russeifa', slug: 'russeifa' },
  { name: 'Windhoek', slug: 'windhoek' },
  { name: 'Tshikapa', slug: 'tshikapa' },
  { name: 'Kafr ad Dawwār', slug: 'kafr-ad-dawwar' },
  { name: 'Tokushima', slug: 'tokushima' },
  { name: 'Haifa', slug: 'haifa' },
  { name: 'Sterlitamak', slug: 'sterlitamak' },
  { name: 'Ha\'il', slug: 'hail' },
  { name: 'Eixample', slug: 'eixample' },
  { name: 'Bagerhat', slug: 'bagerhat' },
  { name: 'Chengzhong', slug: 'chengzhong' },
  { name: 'Wuzhou', slug: 'wuzhou' },
  { name: 'Chula Vista', slug: 'chula-vista' },
  { name: 'Hulan Ergi', slug: 'hulan-ergi' },
  { name: 'Aizawl', slug: 'aizawl' },
  { name: 'Aachen', slug: 'aachen' },
  { name: 'Sumqayıt', slug: 'sumqayt' },
  { name: 'Mantampay', slug: 'mantampay' },
  { name: 'Petrozavodsk', slug: 'petrozavodsk' },
  { name: 'El Daein', slug: 'el-daein' },
  { name: 'Umuahia', slug: 'umuahia' },
  { name: 'Uruapan', slug: 'uruapan' },
  { name: 'Jersey City', slug: 'jersey-city' },
  { name: 'Mianyang', slug: 'mianyang' },
  { name: 'Sivas', slug: 'sivas' },
  { name: 'Witbank', slug: 'witbank' },
  { name: 'Aktobe', slug: 'aktobe' },
  { name: 'Paraná', slug: 'parana' },
  { name: 'Jālna', slug: 'jalna' },
  { name: 'Lal Bahadur Nagar', slug: 'lal-bahadur-nagar' },
  { name: 'Mönchengladbach', slug: 'monchengladbach' },
  { name: 'Markham', slug: 'markham' },
  { name: 'Dewas', slug: 'dewas' },
  { name: 'Sincelejo', slug: 'sincelejo' },
  { name: 'Tongliao', slug: 'tongliao' },
  { name: 'Uberaba', slug: 'uberaba' },
  { name: 'Chandler', slug: 'chandler' },
  { name: 'Fort Wayne', slug: 'fort-wayne' },
  { name: 'Plymouth', slug: 'plymouth' },
  { name: 'Baranagar', slug: 'baranagar' },
  { name: 'Karamay', slug: 'karamay' },
  { name: 'Aral', slug: 'aral' },
  { name: 'Nakuru', slug: 'nakuru' },
  { name: 'Cần Thơ', slug: 'can-tho' },
  { name: 'Augsburg', slug: 'augsburg' },
  { name: 'Hiratsuka', slug: 'hiratsuka' },
  { name: 'Gajuwaka', slug: 'gajuwaka' },
  { name: 'Jiujiang', slug: 'jiujiang' },
  { name: 'Popayán', slug: 'popayan' },
  { name: 'Najrān', slug: 'najran' },
  { name: 'Mukalla', slug: 'mukalla' },
  { name: 'Buffalo', slug: 'buffalo' },
  { name: 'Luton', slug: 'luton' },
  { name: 'Pekalongan', slug: 'pekalongan' },
  { name: 'Cumaná', slug: 'cumana' },
  { name: 'Satna', slug: 'satna' },
  { name: 'Rio Branco', slug: 'rio-branco' },
  { name: 'Durham', slug: 'durham' },
  { name: 'Etāwah', slug: 'etawah' },
  { name: 'Gómez Palacio', slug: 'gomez-palacio' },
  { name: 'Cascavel', slug: 'cascavel' },
  { name: 'St. Petersburg', slug: 'st-petersburg' },
  { name: 'L\'Hospitalet de Llobregat', slug: 'lhospitalet-de-llobregat' },
  { name: 'Ondo', slug: 'ondo' },
  { name: 'Chimoio', slug: 'chimoio' },
  { name: 'Irvine', slug: 'irvine' },
  { name: 'Espoo', slug: 'espoo' },
  { name: 'Latina', slug: 'latina' },
  { name: 'Los Mochis', slug: 'los-mochis' },
  { name: 'Bratsk', slug: 'bratsk' },
  { name: 'Pachuca de Soto', slug: 'pachuca-de-soto' },
  { name: 'Tarsus', slug: 'tarsus' },
  { name: 'Laredo', slug: 'laredo' },
  { name: 'Sari', slug: 'sari' },
  { name: 'Durg', slug: 'durg' },
  { name: 'Rivne', slug: 'rivne' },
  { name: 'Oaxaca', slug: 'oaxaca' },
  { name: 'Soledad de Graciano Sánchez', slug: 'soledad-de-graciano-sanchez' },
  { name: 'Turpan', slug: 'turpan' },
  { name: 'Ikot Ekpene', slug: 'ikot-ekpene' },
  { name: 'Heze', slug: 'heze' },
  { name: 'Yamagata', slug: 'yamagata' },
  { name: 'Cirebon', slug: 'cirebon' },
  { name: 'Novo Hamburgo', slug: 'novo-hamburgo' },
  { name: 'Cox’s Bāzār', slug: 'coxs-bazar' },
  { name: 'Gdynia', slug: 'gdynia' },
  { name: 'Carabanchel', slug: 'carabanchel' },
  { name: 'Naihāti', slug: 'naihati' },
  { name: 'Vitória da Conquista', slug: 'vitoria-da-conquista' },
  { name: 'Laohekou', slug: 'laohekou' },
  { name: 'Talcahuano', slug: 'talcahuano' },
  { name: 'Richards Bay', slug: 'richards-bay' },
  { name: 'Wolverhampton', slug: 'wolverhampton' },
  { name: 'El Fasher', slug: 'el-fasher' },
  { name: 'Woodlands', slug: 'woodlands' },
  { name: 'Thiès Nones', slug: 'thies-nones' },
  { name: 'Dire Dawa', slug: 'dire-dawa' },
  { name: 'Floridablanca', slug: 'floridablanca' },
  { name: 'Suihua', slug: 'suihua' },
  { name: 'Barueri', slug: 'barueri' },
  { name: 'Borūjerd', slug: 'borujerd' },
  { name: 'Eimsbüttel', slug: 'eimsbuttel' },
  { name: 'Liupanshui', slug: 'liupanshui' },
  { name: 'Qarchak', slug: 'qarchak' },
  { name: 'Santiago de Surco', slug: 'santiago-de-surco' },
  { name: 'Taubaté', slug: 'taubate' },
  { name: 'Nanyang', slug: 'nanyang' },
  { name: 'San Fernando', slug: 'san-fernando' },
  { name: 'Morogoro', slug: 'morogoro' },
  { name: 'Governador Valadares', slug: 'governador-valadares' },
  { name: 'Tirupati', slug: 'tirupati' },
  { name: 'Banda Aceh', slug: 'banda-aceh' },
  { name: 'Wafangdian', slug: 'wafangdian' },
  { name: 'Sonīpat', slug: 'sonipat' },
  { name: 'Santa Clara', slug: 'santa-clara' },
  { name: 'Iwo', slug: 'iwo' },
  { name: 'Libertad', slug: 'libertad' },
  { name: 'Gombe', slug: 'gombe' },
  { name: 'Altona', slug: 'altona' },
  { name: 'Āvadi', slug: 'avadi' },
  { name: 'Praia Grande', slug: 'praia-grande' },
  { name: 'Port-de-Paix', slug: 'port-de-paix' },
  { name: 'Colonia del Valle', slug: 'colonia-del-valle' },
  { name: 'Niš', slug: 'nis' },
  { name: 'Singa', slug: 'singa' },
  { name: 'San Bernardo', slug: 'san-bernardo' },
  { name: 'Várzea Grande', slug: 'varzea-grande' },
  { name: 'Porto', slug: 'porto' },
  { name: 'Volta Redonda', slug: 'volta-redonda' },
  { name: 'Navotas', slug: 'navotas' },
  { name: 'Kropyvnytskyi', slug: 'kropyvnytskyi' },
  { name: 'Santa Maria', slug: 'santa-maria' },
  { name: 'Lubbock', slug: 'lubbock' },
  { name: 'Madison', slug: 'madison' },
  { name: 'Tehuacán', slug: 'tehuacan' },
  { name: 'Fukui-shi', slug: 'fukui-shi' },
  { name: 'Kamianske', slug: 'kamianske' },
  { name: 'Montpellier', slug: 'montpellier' },
  { name: 'Jimeta', slug: 'jimeta' },
  { name: 'Częstochowa', slug: 'czestochowa' },
  { name: 'Tiruvottiyūr', slug: 'tiruvottiyur' },
  { name: 'Palmira', slug: 'palmira' },
  { name: 'Bukhara', slug: 'bukhara' },
  { name: 'City of Westminster', slug: 'city-of-westminster' },
  { name: 'Gilbert', slug: 'gilbert' },
  { name: 'Saugor', slug: 'saugor' },
  { name: 'Udon Thani', slug: 'udon-thani' },
  { name: 'Chemnitz', slug: 'chemnitz' },
  { name: 'Ica', slug: 'ica' },
  { name: 'Orsk', slug: 'orsk' },
  { name: 'Vanderbijlpark', slug: 'vanderbijlpark' },
  { name: 'San Cristóbal', slug: 'san-cristobal' },
  { name: 'Mito', slug: 'mito' },
  { name: 'Norfolk', slug: 'norfolk' },
  { name: 'Rizhao', slug: 'rizhao' },
  { name: 'Southampton', slug: 'southampton' },
  { name: 'Kyain Seikgyi Township', slug: 'kyain-seikgyi-township' },
  { name: 'A Coruña', slug: 'a-coruna' },
  { name: 'Mau', slug: 'mau' },
  { name: 'Shimonoseki', slug: 'shimonoseki' },
  { name: 'Juliaca', slug: 'juliaca' },
  { name: 'Ji’an', slug: 'jian' },
  { name: 'Gorgān', slug: 'gorgan' },
  { name: 'Nizhnevartovsk', slug: 'nizhnevartovsk' },
  { name: 'Braunschweig', slug: 'braunschweig' },
  { name: 'Hebi', slug: 'hebi' },
  { name: 'Bago', slug: 'bago' },
  { name: 'Bihār Sharīf', slug: 'bihar-sharif' },
  { name: 'Baruta', slug: 'baruta' },
  { name: 'Merlo', slug: 'merlo' },
  { name: 'Puente de Vallecas', slug: 'puente-de-vallecas' },
  { name: 'Trabzon', slug: 'trabzon' },
  { name: 'Jessore', slug: 'jessore' },
  { name: 'Manisa', slug: 'manisa' },
  { name: 'Louisville', slug: 'louisville' },
  { name: 'Santa Luzia', slug: 'santa-luzia' },
  { name: 'Gunsan', slug: 'gunsan' },
  { name: 'Wŏnju', slug: 'wonju' },
  { name: 'Musaffah', slug: 'musaffah' },
  { name: 'Angarsk', slug: 'angarsk' },
  { name: 'Mar’ino', slug: 'marino' },
  { name: 'Hāpur', slug: 'hapur' },
  { name: 'Bathinda', slug: 'bathinda' },
  { name: 'Deir ez-Zor', slug: 'deir-ez-zor' },
  { name: 'Huayin', slug: 'huayin' },
  { name: 'Berbera', slug: 'berbera' },
  { name: 'Ojo de Agua', slug: 'ojo-de-agua' },
  { name: 'Gatineau', slug: 'gatineau' },
  { name: 'Yibin', slug: 'yibin' },
  { name: 'Neuquén', slug: 'neuquen' },
  { name: 'Tacloban', slug: 'tacloban' },
  { name: 'Novorossiysk', slug: 'novorossiysk' },
  { name: 'Reno', slug: 'reno' },
  { name: 'Aswan', slug: 'aswan' },
  { name: 'Winston-Salem', slug: 'winston-salem' },
  { name: 'Farrukhābād', slug: 'farrukhabad' },
  { name: 'Sancaktepe', slug: 'sancaktepe' },
  { name: 'Takasaki', slug: 'takasaki' },
  { name: 'Anantapur', slug: 'anantapur' },
  { name: 'Buenaventura', slug: 'buenaventura' },
  { name: 'Lankaran', slug: 'lankaran' },
  { name: 'Glendale', slug: 'glendale' },
  { name: 'Fuji', slug: 'fuji' },
  { name: 'Khimki', slug: 'khimki' },
  { name: 'Blackpool', slug: 'blackpool' },
  { name: 'Xiantao', slug: 'xiantao' },
  { name: 'Hachinohe', slug: 'hachinohe' },
  { name: 'Vaughan', slug: 'vaughan' },
  { name: 'Gravataí', slug: 'gravatai' },
  { name: 'Neyagawa', slug: 'neyagawa' },
  { name: 'Magdalena Contreras', slug: 'magdalena-contreras' },
  { name: 'Nāgarpur', slug: 'nagarpur' },
  { name: 'Kurume', slug: 'kurume' },
  { name: 'Balıkesir', slug: 'balkesir' },
  { name: 'Temuco', slug: 'temuco' },
  { name: 'Krefeld', slug: 'krefeld' },
  { name: 'Seeb', slug: 'seeb' },
  { name: 'Århus', slug: 'arhus' },
  { name: 'Sasebo', slug: 'sasebo' },
  { name: 'Batangas', slug: 'batangas' },
  { name: 'Al Jubayl', slug: 'al-jubayl' },
  { name: 'Pathein', slug: 'pathein' },
  { name: 'Tegal', slug: 'tegal' },
  { name: 'Hialeah', slug: 'hialeah' },
  { name: 'Djougou', slug: 'djougou' },
  { name: 'Sylhet', slug: 'sylhet' },
  { name: 'Garland', slug: 'garland' },
  { name: 'Ratlām', slug: 'ratlam' },
  { name: 'Scottsdale', slug: 'scottsdale' },
  { name: 'Irving', slug: 'irving' },
  { name: 'Košice', slug: 'kosice' },
  { name: 'Chernivtsi', slug: 'chernivtsi' },
  { name: 'Dera Ghazi Khan', slug: 'dera-ghazi-khan' },
  { name: 'Coatzacoalcos', slug: 'coatzacoalcos' },
  { name: 'Yuci', slug: 'yuci' },
  { name: 'Sant Martí', slug: 'sant-marti' },
  { name: 'Sahiwal', slug: 'sahiwal' },
  { name: 'Ternopil', slug: 'ternopil' },
  { name: 'Gasteiz / Vitoria', slug: 'gasteiz-vitoria' },
  { name: 'Yakutsk', slug: 'yakutsk' },
  { name: 'Chesapeake', slug: 'chesapeake' },
  { name: 'Caruaru', slug: 'caruaru' },
  { name: 'Qinā', slug: 'qina' },
  { name: 'Boa Vista', slug: 'boa-vista' },
  { name: 'Kediri', slug: 'kediri' },
  { name: 'Georgetown', slug: 'georgetown' },
  { name: 'Ramagundam', slug: 'ramagundam' },
  { name: 'Kismayo', slug: 'kismayo' },
  { name: 'Ibb', slug: 'ibb' },
  { name: 'Türkmenabat', slug: 'turkmenabat' },
  { name: 'North Las Vegas', slug: 'north-las-vegas' },
  { name: 'Granada', slug: 'granada' },
  { name: 'Nizhnekamsk', slug: 'nizhnekamsk' },
  { name: 'Porto-Novo', slug: 'porto-novo' },
  { name: 'Halle (Saale)', slug: 'halle-saale' },
  { name: 'Kitchener', slug: 'kitchener' },
  { name: 'Centurion', slug: 'centurion' },
  { name: 'Magugpo Poblacion', slug: 'magugpo-poblacion' },
  { name: 'Hamburg-Mitte', slug: 'hamburg-mitte' },
  { name: 'Dzerzhinsk', slug: 'dzerzhinsk' },
  { name: 'Takoradi', slug: 'takoradi' },
  { name: 'Kiel', slug: 'kiel' },
  { name: 'Linfen', slug: 'linfen' },
  { name: 'Fremont', slug: 'fremont' },
  { name: 'Beni', slug: 'beni' },
  { name: 'Bordeaux', slug: 'bordeaux' },
  { name: 'Gangānagar', slug: 'ganganagar' },
  { name: 'Chigasaki', slug: 'chigasaki' },
  { name: 'Gent', slug: 'gent' },
  { name: 'Taytay', slug: 'taytay' },
  { name: 'Sōka', slug: 'soka' },
  { name: 'Ngaoundéré', slug: 'ngaoundere' },
  { name: 'Suncheon', slug: 'suncheon' },
  { name: 'Sejong', slug: 'sejong' },
  { name: 'José C. Paz', slug: 'jose-c-paz' },
  { name: 'Syktyvkar', slug: 'syktyvkar' },
  { name: 'Elche', slug: 'elche' },
  { name: 'Marka', slug: 'marka' },
  { name: 'Nukus', slug: 'nukus' },
  { name: 'Quilmes', slug: 'quilmes' },
  { name: 'Ḩalwān', slug: 'halwan' },
  { name: 'Atani', slug: 'atani' },
  { name: 'Milton Keynes', slug: 'milton-keynes' },
  { name: 'Magdeburg', slug: 'magdeburg' },
  { name: 'Rio Verde', slug: 'rio-verde' },
  { name: 'Nawabshah', slug: 'nawabshah' },
  { name: 'Bharatpur', slug: 'bharatpur' },
  { name: 'Longueuil', slug: 'longueuil' },
  { name: 'Atsugi', slug: 'atsugi' },
  { name: 'Croix-des-Bouquets', slug: 'croix-des-bouquets' },
  { name: 'Uitenhage', slug: 'uitenhage' },
  { name: 'Ploieşti', slug: 'ploiesti' },
  { name: 'Sungai Petani', slug: 'sungai-petani' },
  { name: 'Binjai', slug: 'binjai' },
  { name: 'Lucena', slug: 'lucena' },
  { name: 'Ipatinga', slug: 'ipatinga' },
  { name: 'Karīmnagar', slug: 'karimnagar' },
  { name: 'Baton Rouge', slug: 'baton-rouge' },
  { name: 'Rạch Giá', slug: 'rach-gia' },
  { name: 'Lille', slug: 'lille' },
  { name: 'Miri', slug: 'miri' },
  { name: 'Ciudad Lineal', slug: 'ciudad-lineal' },
  { name: 'Bexley', slug: 'bexley' },
  { name: 'Sumaré', slug: 'sumare' },
  { name: 'Damanhūr', slug: 'damanhur' },
  { name: 'Nassau', slug: 'nassau' },
  { name: 'San Lorenzo', slug: 'san-lorenzo' },
  { name: 'Iquique', slug: 'iquique' },
  { name: 'Kremenchuk', slug: 'kremenchuk' },
  { name: 'Puducherry', slug: 'puducherry' },
  { name: 'Sosnowiec', slug: 'sosnowiec' },
  { name: 'Diez de Octubre', slug: 'diez-de-octubre' },
  { name: 'Al Minyā', slug: 'al-minya' },
  { name: 'Staryy Oskol', slug: 'staryy-oskol' },
  { name: 'Liaocheng', slug: 'liaocheng' },
  { name: 'Gusau', slug: 'gusau' },
  { name: 'Neue Neustadt', slug: 'neue-neustadt' },
  { name: 'Radom', slug: 'radom' },
  { name: 'Pilar', slug: 'pilar' },
  { name: 'Shrīrāmpur', slug: 'shrirampur' },
  { name: 'Fendou', slug: 'fendou' },
  { name: 'Sabzevar', slug: 'sabzevar' },
  { name: 'Huambo', slug: 'huambo' },
  { name: 'Groznyy', slug: 'groznyy' },
  { name: 'Geelong', slug: 'geelong' },
  { name: 'Rāichūr', slug: 'raichur' },
  { name: 'Huanggang', slug: 'huanggang' },
  { name: 'Quthbullapur', slug: 'quthbullapur' },
  { name: 'Mubi', slug: 'mubi' },
  { name: 'Sector 1', slug: 'sector-1' },
  { name: 'Bukavu', slug: 'bukavu' },
  { name: 'Lexington', slug: 'lexington' },
  { name: 'Juazeiro do Norte', slug: 'juazeiro-do-norte' },
  { name: 'Mymensingh', slug: 'mymensingh' },
  { name: 'Karnāl', slug: 'karnal' },
  { name: 'Roodepoort', slug: 'roodepoort' },
  { name: 'Tanga', slug: 'tanga' },
  { name: 'Jingling', slug: 'jingling' },
  { name: 'Sucre', slug: 'sucre' },
  { name: 'Nacala', slug: 'nacala' },
  { name: 'Ashdod', slug: 'ashdod' },
  { name: 'Minamirinkan', slug: 'minamirinkan' },
  { name: 'Oviedo', slug: 'oviedo' },
  { name: 'Paramaribo', slug: 'paramaribo' },
  { name: 'Adıyaman', slug: 'adyaman' },
  { name: 'Arrah', slug: 'arrah' },
  { name: 'Okara', slug: 'okara' },
  { name: 'Nārāyanganj', slug: 'narayanganj' },
  { name: 'Tongchuanshi', slug: 'tongchuanshi' },
  { name: 'Imphal', slug: 'imphal' },
  { name: 'Najafābād', slug: 'najafabad' },
  { name: 'Paradise', slug: 'paradise' },
  { name: 'Qarshi', slug: 'qarshi' },
  { name: 'Gosāba', slug: 'gosaba' },
  { name: 'Puerto Princesa', slug: 'puerto-princesa' },
  { name: 'Xintai', slug: 'xintai' },
  { name: 'Santa Cruz de Tenerife', slug: 'santa-cruz-de-tenerife' },
  { name: 'Haeju', slug: 'haeju' },
  { name: 'Graz', slug: 'graz' },
  { name: 'Ikire', slug: 'ikire' },
  { name: 'Embu', slug: 'embu' },
  { name: 'Formosa', slug: 'formosa' },
  { name: 'Shakhty', slug: 'shakhty' },
  { name: 'Blagoveshchensk', slug: 'blagoveshchensk' },
  { name: 'Olongapo', slug: 'olongapo' },
  { name: 'Banja Luka', slug: 'banja-luka' },
  { name: 'Thị Xã Phú Mỹ', slug: 'thi-xa-phu-my' },
  { name: 'Neyshābūr', slug: 'neyshabur' },
  { name: 'Wuxue', slug: 'wuxue' },
  { name: 'Babruysk', slug: 'babruysk' },
  { name: 'Rishon LeẔiyyon', slug: 'rishon-leziyyon' },
  { name: 'Campeche', slug: 'campeche' },
  { name: 'Richmond', slug: 'richmond' },
  { name: 'Cabanatuan City', slug: 'cabanatuan-city' },
  { name: 'Fuencarral-El Pardo', slug: 'fuencarral-el-pardo' },
  { name: 'Mirzāpur', slug: 'mirzapur' },
  { name: 'Messina', slug: 'messina' },
  { name: 'Dehiwala-Mount Lavinia', slug: 'dehiwala-mount-lavinia' },
  { name: 'Takarazuka', slug: 'takarazuka' },
  { name: 'Kharagpur', slug: 'kharagpur' },
  { name: 'Dhanbād', slug: 'dhanbad' },
  { name: 'Tanjore', slug: 'tanjore' },
  { name: 'Badalona', slug: 'badalona' },
  { name: 'Ageoshimo', slug: 'ageoshimo' },
  { name: 'Binangonan', slug: 'binangonan' },
  { name: 'Oberhausen', slug: 'oberhausen' },
  { name: 'Chon Buri', slug: 'chon-buri' },
  { name: 'Verona', slug: 'verona' },
  { name: 'Prokop’yevsk', slug: 'prokopyevsk' },
  { name: 'Eldoret', slug: 'eldoret' },
  { name: 'Wuhai', slug: 'wuhai' },
  { name: 'Bertoua', slug: 'bertoua' },
  { name: 'Imperatriz', slug: 'imperatriz' },
  { name: 'San Pedro de Macorís', slug: 'san-pedro-de-macoris' },
  { name: 'Amarnāth', slug: 'amarnath' },
  { name: 'Taiping', slug: 'taiping' },
  { name: 'Alor Setar', slug: 'alor-setar' },
  { name: 'Purwokerto', slug: 'purwokerto' },
  { name: 'Jamaica', slug: 'jamaica' },
  { name: 'Rybinsk', slug: 'rybinsk' },
  { name: 'Hobart', slug: 'hobart' },
  { name: 'Santa Rosa', slug: 'santa-rosa' },
  { name: 'Kisumu', slug: 'kisumu' },
  { name: 'San Bernardino', slug: 'san-bernardino' },
  { name: 'Imus', slug: 'imus' },
  { name: 'Vykhino-Zhulebino', slug: 'vykhino-zhulebino' },
  { name: 'Freiburg', slug: 'freiburg' },
  { name: 'Northampton', slug: 'northampton' },
  { name: 'Purwakarta', slug: 'purwakarta' },
  { name: 'Zelenograd', slug: 'zelenograd' },
  { name: 'Archway', slug: 'archway' },
  { name: 'Mirpur Khas', slug: 'mirpur-khas' },
  { name: 'Daloa', slug: 'daloa' },
  { name: 'Mek\'ele', slug: 'mekele' },
  { name: 'Biysk', slug: 'biysk' },
  { name: 'Concepción', slug: 'concepcion' },
  { name: 'Novi Sad', slug: 'novi-sad' },
  { name: 'Monclova', slug: 'monclova' },
  { name: 'Mucumpiz', slug: 'mucumpiz' },
  { name: 'Velikiy Novgorod', slug: 'velikiy-novgorod' },
  { name: 'Owerri', slug: 'owerri' },
  { name: 'Centralniy', slug: 'centralniy' },
  { name: 'Shagamu', slug: 'shagamu' },
  { name: 'Taboão da Serra', slug: 'taboao-da-serra' },
  { name: 'Nazrēt', slug: 'nazret' },
  { name: 'Nāgercoil', slug: 'nagercoil' },
  { name: 'Lutsk', slug: 'lutsk' },
  { name: 'Bergen', slug: 'bergen' },
  { name: 'Brăila', slug: 'braila' },
  { name: 'Naz̧arābād', slug: 'nazarabad' },
  { name: 'Guangyuan', slug: 'guangyuan' },
  { name: 'Būkān', slug: 'bukan' },
  { name: 'Spokane', slug: 'spokane' },
  { name: 'Norwich', slug: 'norwich' },
  { name: 'Jacareí', slug: 'jacarei' },
  { name: 'Chōfu', slug: 'chofu' },
  { name: 'Loa Janan', slug: 'loa-janan' },
  { name: 'Rancagua', slug: 'rancagua' },
  { name: 'Mokotów', slug: 'mokotow' },
  { name: 'Nogales', slug: 'nogales' },
  { name: 'Bukit Mertajam', slug: 'bukit-mertajam' },
  { name: 'Lipa City', slug: 'lipa-city' },
  { name: 'Marília', slug: 'marilia' },
  { name: 'Lübeck', slug: 'lubeck' },
  { name: 'Sepang', slug: 'sepang' },
  { name: 'Esenyurt', slug: 'esenyurt' },
  { name: 'Modesto', slug: 'modesto' },
  { name: 'Kırıkkale', slug: 'krkkale' },
  { name: 'Hailar', slug: 'hailar' },
  { name: 'Terrassa', slug: 'terrassa' },
  { name: 'Abha', slug: 'abha' },
  { name: 'Tarhuna', slug: 'tarhuna' },
  { name: 'Idkū', slug: 'idku' },
  { name: 'Matsumoto', slug: 'matsumoto' },
  { name: 'Daliang', slug: 'daliang' },
  { name: 'Qui Nhon', slug: 'qui-nhon' },
  { name: 'Des Moines', slug: 'des-moines' },
  { name: 'Pāli', slug: 'pali' },
  { name: 'Arroyo Naranjo', slug: 'arroyo-naranjo' },
  { name: 'Bogra', slug: 'bogra' },
  { name: 'Kostanay', slug: 'kostanay' },
  { name: 'Antakya', slug: 'antakya' },
  { name: 'Rochester', slug: 'rochester' },
  { name: 'Chuncheon', slug: 'chuncheon' },
  { name: 'Vũng Tàu', slug: 'vung-tau' },
  { name: 'Eindhoven', slug: 'eindhoven' },
  { name: 'Pematangsiantar', slug: 'pematangsiantar' },
  { name: 'Kanggye', slug: 'kanggye' },
  { name: 'Presidente Prudente', slug: 'presidente-prudente' },
  { name: 'Sanming', slug: 'sanming' },
  { name: 'Sohag', slug: 'sohag' },
  { name: 'Rennes', slug: 'rennes' },
  { name: 'São Leopoldo', slug: 'sao-leopoldo' },
  { name: 'Ijebu-Ode', slug: 'ijebu-ode' },
  { name: 'Yamunānagar', slug: 'yamunanagar' },
  { name: 'Nakhon Ratchasima', slug: 'nakhon-ratchasima' },
  { name: 'Toruń', slug: 'torun' },
  { name: 'Oruro', slug: 'oruro' },
  { name: 'Kielce', slug: 'kielce' },
  { name: 'Rewa', slug: 'rewa' },
  { name: 'La Romana', slug: 'la-romana' },
  { name: 'Gaborone', slug: 'gaborone' },
  { name: 'Hangu', slug: 'hangu' },
  { name: 'Maryvale', slug: 'maryvale' },
  { name: 'Tacoma', slug: 'tacoma' },
  { name: 'Lobito', slug: 'lobito' },
  { name: 'North Shore', slug: 'north-shore' },
  { name: 'Ciputat', slug: 'ciputat' },
  { name: 'Sirjan', slug: 'sirjan' },
  { name: 'San Pablo', slug: 'san-pablo' },
  { name: 'Jerez de la Frontera', slug: 'jerez-de-la-frontera' },
  { name: 'Fontana', slug: 'fontana' },
  { name: 'Oxnard', slug: 'oxnard' },
  { name: 'Ciampea', slug: 'ciampea' },
  { name: 'Kasukabe', slug: 'kasukabe' },
  { name: 'Oradea', slug: 'oradea' },
  { name: 'Annaba', slug: 'annaba' },
  { name: 'Sabadell', slug: 'sabadell' },
  { name: 'Móstoles', slug: 'mostoles' },
  { name: 'Toamasina', slug: 'toamasina' },
  { name: 'Dinājpur', slug: 'dinajpur' },
  { name: 'Buenavista', slug: 'buenavista' },
  { name: 'Itabuna', slug: 'itabuna' },
  { name: 'Kishiwada', slug: 'kishiwada' },
  { name: 'São Carlos', slug: 'sao-carlos' },
  { name: 'Linz', slug: 'linz' },
  { name: 'Alcalá de Henares', slug: 'alcala-de-henares' },
  { name: 'Gaoping', slug: 'gaoping' },
  { name: 'Numazu', slug: 'numazu' },
  { name: 'Ivano-Frankivsk', slug: 'ivano-frankivsk' },
  { name: 'Moreno Valley', slug: 'moreno-valley' },
  { name: 'Secunderabad', slug: 'secunderabad' },
  { name: 'Jōetsu', slug: 'joetsu' },
  { name: 'Debrecen', slug: 'debrecen' },
  { name: 'Bīdar', slug: 'bidar' },
  { name: 'Padova', slug: 'padova' },
  { name: 'Las Tunas', slug: 'las-tunas' },
  { name: 'Sa Dec', slug: 'sa-dec' },
  { name: 'Hortolândia', slug: 'hortolandia' },
  { name: 'Bayamón', slug: 'bayamon' },
  { name: 'Daqing', slug: 'daqing' },
  { name: 'Puerto Vallarta', slug: 'puerto-vallarta' },
  { name: 'Agartala', slug: 'agartala' },
  { name: 'Erfurt', slug: 'erfurt' },
  { name: 'Monghyr', slug: 'monghyr' },
  { name: 'Edéa', slug: 'edea' },
  { name: 'Vasyl\'evsky Ostrov', slug: 'vasylevsky-ostrov' },
  { name: 'Odawara', slug: 'odawara' },
  { name: 'Atsiaman', slug: 'atsiaman' },
  { name: 'Osmaniye', slug: 'osmaniye' },
  { name: 'Burnaby', slug: 'burnaby' },
  { name: 'Bābol', slug: 'babol' },
  { name: 'Burhānpur', slug: 'burhanpur' },
  { name: 'Tampere', slug: 'tampere' },
  { name: 'Tapachula', slug: 'tapachula' },
  { name: 'Yiyang', slug: 'yiyang' },
  { name: 'Çorlu', slug: 'corlu' },
  { name: 'Harburg', slug: 'harburg' },
  { name: 'Linxia Chengguanzhen', slug: 'linxia-chengguanzhen' },
  { name: 'Barisāl', slug: 'barisal' },
  { name: 'Cileungsir', slug: 'cileungsir' },
  { name: 'Nadiād', slug: 'nadiad' },
  { name: 'Mossoró', slug: 'mossoro' },
  { name: 'Pskov', slug: 'pskov' },
  { name: 'Fayetteville', slug: 'fayetteville' },
  { name: 'Yuncheng', slug: 'yuncheng' },
  { name: 'Al Khums', slug: 'al-khums' },
  { name: 'Huntington Beach', slug: 'huntington-beach' },
  { name: 'Favoriten', slug: 'favoriten' },
  { name: 'Chiniot', slug: 'chiniot' },
  { name: 'Itapevi', slug: 'itapevi' },
  { name: 'Chāpra', slug: 'chapra' },
  { name: 'Rengasdengklok', slug: 'rengasdengklok' },
  { name: 'Sete Lagoas', slug: 'sete-lagoas' },
  { name: 'La Pintana', slug: 'la-pintana' },
  { name: 'Yonkers', slug: 'yonkers' },
  { name: 'Chiang Mai', slug: 'chiang-mai' },
  { name: 'Petropavl', slug: 'petropavl' },
  { name: 'Cabimas', slug: 'cabimas' },
  { name: 'Dindigul', slug: 'dindigul' },
  { name: 'Montgomery', slug: 'montgomery' },
  { name: 'Nicosia', slug: 'nicosia' },
  { name: 'Santo Domingo de los Colorados', slug: 'santo-domingo-de-los-colorados' },
  { name: 'Jalālābād', slug: 'jalalabad' },
  { name: 'Ugep', slug: 'ugep' },
  { name: 'Yanbu', slug: 'yanbu' },
  { name: 'Charleroi', slug: 'charleroi' },
  { name: 'São José', slug: 'sao-jose' },
  { name: 'Ladner', slug: 'ladner' },
  { name: 'New Cairo', slug: 'new-cairo' },
  { name: 'Sumedang', slug: 'sumedang' },
  { name: 'Petaẖ Tiqwa', slug: 'petah-tiqwa' },
  { name: 'Panchkula', slug: 'panchkula' },
  { name: 'Thika', slug: 'thika' },
  { name: 'Osh', slug: 'osh' },
  { name: 'Oral', slug: 'oral' },
  { name: 'Az Zāwīyah', slug: 'az-zawiyah' },
  { name: 'Salé Al Jadida', slug: 'sale-al-jadida' },
  { name: 'Chakwama', slug: 'chakwama' },
  { name: 'Pokhara', slug: 'pokhara' },
  { name: 'Shahkot', slug: 'shahkot' },
  { name: 'Severnyy', slug: 'severnyy' },
  { name: 'Sīkar', slug: 'sikar' },
  { name: 'Tilburg', slug: 'tilburg' },
  { name: 'Balakovo', slug: 'balakovo' },
  { name: 'Armavir', slug: 'armavir' },
  { name: 'Kamoke', slug: 'kamoke' },
  { name: 'Saidpur', slug: 'saidpur' },
  { name: 'Āmol', slug: 'amol' },
  { name: 'Bila Tserkva', slug: 'bila-tserkva' },
  { name: 'Dudley', slug: 'dudley' },
  { name: 'Hagen', slug: 'hagen' },
  { name: 'Saskatoon', slug: 'saskatoon' },
  { name: 'Gliwice', slug: 'gliwice' },
  { name: 'Changji', slug: 'changji' },
  { name: 'Malolos', slug: 'malolos' },
  { name: 'Amarillo', slug: 'amarillo' },
  { name: 'Bulandshahr', slug: 'bulandshahr' },
  { name: 'Capiatá', slug: 'capiata' },
  { name: 'Pamplona', slug: 'pamplona' },
  { name: 'Purnia', slug: 'purnia' },
  { name: 'Kaiyuan', slug: 'kaiyuan' },
  { name: 'Rostock', slug: 'rostock' },
  { name: 'Sibu', slug: 'sibu' },
  { name: 'Arnavutköy', slug: 'arnavutkoy' },
  { name: 'Machala', slug: 'machala' },
  { name: 'Little Rock', slug: 'little-rock' },
  { name: 'Hospet', slug: 'hospet' },
  { name: 'Fuenlabrada', slug: 'fuenlabrada' },
  { name: 'Mentougou', slug: 'mentougou' },
  { name: 'Akron', slug: 'akron' },
  { name: 'Talca', slug: 'talca' },
  { name: 'Gurgaon', slug: 'gurgaon' },
  { name: 'Ciudad Madero', slug: 'ciudad-madero' },
  { name: 'Shreveport', slug: 'shreveport' },
  { name: 'Ðà Lạt', slug: 'a-lat' },
  { name: 'Bīrjand', slug: 'birjand' },
  { name: 'Vientiane', slug: 'vientiane' },
  { name: 'Aberdeen', slug: 'aberdeen' },
  { name: 'Kure', slug: 'kure' },
  { name: 'İzmit', slug: 'izmit' },
  { name: 'Reims', slug: 'reims' },
  { name: 'Laayoune', slug: 'laayoune' },
  { name: 'Palmas', slug: 'palmas' },
  { name: 'Parauapebas', slug: 'parauapebas' },
  { name: 'Icheon-si', slug: 'icheon-si' },
  { name: 'Townsville', slug: 'townsville' },
  { name: 'Sambhal', slug: 'sambhal' },
  { name: 'Americana', slug: 'americana' },
  { name: 'Engel’s', slug: 'engels' },
  { name: 'Gandhinagar', slug: 'gandhinagar' },
  { name: 'Burgas', slug: 'burgas' },
  { name: 'Murwāra', slug: 'murwara' },
  { name: 'Nagaoka', slug: 'nagaoka' },
  { name: 'Guri-si', slug: 'guri-si' },
  { name: 'Coro', slug: 'coro' },
  { name: 'Nishi-Tokyo-shi', slug: 'nishi-tokyo-shi' },
  { name: 'Xinhui', slug: 'xinhui' },
  { name: 'Grand Rapids', slug: 'grand-rapids' },
  { name: 'Kendari', slug: 'kendari' },
  { name: 'Petrolina', slug: 'petrolina' },
  { name: 'Yamoussoukro', slug: 'yamoussoukro' },
  { name: 'Kassel', slug: 'kassel' },
  { name: 'Nāngloi Jāt', slug: 'nangloi-jat' },
  { name: 'Severodvinsk', slug: 'severodvinsk' },
  { name: 'Mobile', slug: 'mobile' },
  { name: 'Portsmouth', slug: 'portsmouth' },
  { name: 'Nnewi', slug: 'nnewi' },
  { name: 'Parung', slug: 'parung' },
  { name: 'Divinópolis', slug: 'divinopolis' },
  { name: 'Başakşehir', slug: 'basaksehir' },
  { name: 'Ezhou', slug: 'ezhou' },
  { name: 'Maracanaú', slug: 'maracanau' },
  { name: 'Itami', slug: 'itami' },
  { name: 'Nam Định', slug: 'nam-inh' },
  { name: 'Uji', slug: 'uji' },
  { name: 'Machilīpatnam', slug: 'machilipatnam' },
  { name: 'Hyesan', slug: 'hyesan' },
  { name: 'Salt Lake City', slug: 'salt-lake-city' },
  { name: 'Bayamo', slug: 'bayamo' },
  { name: 'Katihar', slug: 'katihar' },
  { name: 'Tanjung Pinang', slug: 'tanjung-pinang' },
  { name: 'Pār Naogaon', slug: 'par-naogaon' },
  { name: 'Newcastle upon Tyne', slug: 'newcastle-upon-tyne' },
  { name: 'Klaipėda', slug: 'klaipeda' },
  { name: 'Zabrze', slug: 'zabrze' },
  { name: 'Bojnūrd', slug: 'bojnurd' },
  { name: 'Guatire', slug: 'guatire' },
  { name: 'Humen', slug: 'humen' },
  { name: 'Sidi Bel Abbès', slug: 'sidi-bel-abbes' },
  { name: 'Hat Yai', slug: 'hat-yai' },
  { name: 'Haicheng', slug: 'haicheng' },
  { name: 'Suzuka', slug: 'suzuka' },
  { name: 'Zinder', slug: 'zinder' },
  { name: 'Curug', slug: 'curug' },
  { name: 'Barrancabermeja', slug: 'barrancabermeja' },
  { name: 'Zlatoust', slug: 'zlatoust' },
  { name: 'Ormoc', slug: 'ormoc' },
  { name: 'Bhiwāni', slug: 'bhiwani' },
  { name: 'Huntsville', slug: 'huntsville' },
  { name: 'Zoucheng', slug: 'zoucheng' },
  { name: 'Cork', slug: 'cork' },
  { name: 'Al Fallūjah', slug: 'al-fallujah' },
  { name: 'Ise-Ekiti', slug: 'ise-ekiti' },
  { name: 'Vantaa', slug: 'vantaa' },
  { name: 'Kōfu', slug: 'kofu' },
  { name: 'Paarl', slug: 'paarl' },
  { name: 'Tallahassee', slug: 'tallahassee' },
  { name: 'Saddiqabad', slug: 'saddiqabad' },
  { name: 'Banī Suwayf', slug: 'bani-suwayf' },
  { name: 'Planaltina', slug: 'planaltina' },
  { name: 'Sunrise Manor', slug: 'sunrise-manor' },
  { name: 'Syzran’', slug: 'syzran' },
  { name: 'Bytom', slug: 'bytom' },
  { name: 'Mwene-Ditu', slug: 'mwene-ditu' },
  { name: 'Panalanoy', slug: 'panalanoy' },
  { name: 'Izumi', slug: 'izumi' },
  { name: 'Santarém', slug: 'santarem' },
  { name: 'Wanxian', slug: 'wanxian' },
  { name: 'Kabwe', slug: 'kabwe' },
  { name: 'Quelimane', slug: 'quelimane' },
  { name: 'San Fernando del Valle de Catamarca', slug: 'san-fernando-del-valle-de-catamarca' },
  { name: 'Almería', slug: 'almeria' },
  { name: 'Camaçari', slug: 'camacari' },
  { name: 'Labuan Bajo', slug: 'labuan-bajo' },
  { name: 'Cibinong', slug: 'cibinong' },
  { name: 'Donghai', slug: 'donghai' },
  { name: 'Boyeros', slug: 'boyeros' },
  { name: 'Baiyin', slug: 'baiyin' },
  { name: 'Mabalacat City', slug: 'mabalacat-city' },
  { name: 'Santa Bárbara d\'Oeste', slug: 'santa-barbara-doeste' },
  { name: 'Laizhou', slug: 'laizhou' },
  { name: 'Kultali', slug: 'kultali' },
  { name: 'Praga Południe', slug: 'praga-poudnie' },
  { name: 'Rio Grande', slug: 'rio-grande' },
  { name: 'Grand Prairie', slug: 'grand-prairie' },
  { name: 'Mohammedia', slug: 'mohammedia' },
  { name: 'Sutton', slug: 'sutton' },
  { name: 'Qo‘qon', slug: 'qoqon' },
  { name: 'Petropavlovsk-Kamchatsky', slug: 'petropavlovsk-kamchatsky' },
  { name: 'Chilpancingo', slug: 'chilpancingo' },
  { name: 'Trieste', slug: 'trieste' },
  { name: 'Cachoeiro de Itapemirim', slug: 'cachoeiro-de-itapemirim' },
  { name: 'Donaustadt', slug: 'donaustadt' },
  { name: 'Kikwit', slug: 'kikwit' },
  { name: 'Pinar del Río', slug: 'pinar-del-rio' },
  { name: 'Pagadian', slug: 'pagadian' },
  { name: 'Pābna', slug: 'pabna' },
  { name: 'Cienfuegos', slug: 'cienfuegos' },
  { name: 'Beersheba', slug: 'beersheba' },
  { name: 'Overland Park', slug: 'overland-park' },
  { name: 'Raebareli', slug: 'raebareli' },
  { name: 'Springs', slug: 'springs' },
  { name: 'Shibīn al Kawm', slug: 'shibin-al-kawm' },
  { name: 'Hitachi', slug: 'hitachi' },
  { name: 'Antsirabe', slug: 'antsirabe' },
  { name: 'Zawiya', slug: 'zawiya' },
  { name: 'Madiun', slug: 'madiun' },
  { name: 'Haridwar', slug: 'haridwar' },
  { name: 'Leganés', slug: 'leganes' },
  { name: 'Ad-Damazin', slug: 'ad-damazin' },
  { name: 'Arica', slug: 'arica' },
  { name: 'Le Havre', slug: 'le-havre' },
  { name: 'Swindon', slug: 'swindon' },
  { name: 'Singrauli', slug: 'singrauli' },
  { name: 'Richmond Hill', slug: 'richmond-hill' },
  { name: 'Donostia / San Sebastián', slug: 'donostia-san-sebastian' },
  { name: 'Hamm', slug: 'hamm' },
  { name: 'Knoxville', slug: 'knoxville' },
  { name: 'Jamaame', slug: 'jamaame' },
  { name: 'Poza Rica de Hidalgo', slug: 'poza-rica-de-hidalgo' },
  { name: 'Moratuwa', slug: 'moratuwa' },
  { name: 'Kütahya', slug: 'kutahya' },
  { name: 'Mainz', slug: 'mainz' },
  { name: 'Meycauayan', slug: 'meycauayan' },
  { name: 'Brescia', slug: 'brescia' },
  { name: 'Worcester', slug: 'worcester' },
  { name: 'Zaoyang', slug: 'zaoyang' },
  { name: 'Paltan', slug: 'paltan' },
  { name: 'Jūnāgadh', slug: 'junagadh' },
  { name: 'Mutare', slug: 'mutare' },
  { name: 'Mbandaka', slug: 'mbandaka' },
  { name: 'Pemalang', slug: 'pemalang' },
  { name: 'Quanzhou', slug: 'quanzhou' },
  { name: 'San Luis', slug: 'san-luis' },
  { name: 'Genève', slug: 'geneve' },
  { name: 'Tarlac City', slug: 'tarlac-city' },
  { name: 'Būrewāla', slug: 'burewala' },
  { name: 'Brownsville', slug: 'brownsville' },
  { name: 'Baishan', slug: 'baishan' },
  { name: 'Sūjāngarh', slug: 'sujangarh' },
  { name: 'Zaozhuang', slug: 'zaozhuang' },
  { name: 'Kushiro', slug: 'kushiro' },
  { name: 'Cergy-Pontoise', slug: 'cergy-pontoise' },
  { name: 'Çorum', slug: 'corum' },
  { name: 'Ellore', slug: 'ellore' },
  { name: 'Pātan', slug: 'patan' },
  { name: 'Manta', slug: 'manta' },
  { name: 'Lembang', slug: 'lembang' },
  { name: 'Sants-Montjuïc', slug: 'sants-montjuic' },
  { name: 'Bhusāval', slug: 'bhusaval' },
  { name: 'Pak Kret', slug: 'pak-kret' },
  { name: 'Khandwa', slug: 'khandwa' },
  { name: 'Santander', slug: 'santander' },
  { name: 'Liège', slug: 'liege' },
  { name: 'Cúa', slug: 'cua' },
  { name: 'Sakura', slug: 'sakura' },
  { name: 'Kamensk-Ural’skiy', slug: 'kamensk-uralskiy' },
  { name: 'Itaboraí', slug: 'itaborai' },
  { name: 'Blida', slug: 'blida' },
  { name: 'Newport News', slug: 'newport-news' },
  { name: 'Santa Clarita', slug: 'santa-clarita' },
  { name: 'Biratnagar', slug: 'biratnagar' },
  { name: 'Carletonville', slug: 'carletonville' },
  { name: 'Bahraigh', slug: 'bahraigh' },
  { name: 'Barrie', slug: 'barrie' },
  { name: 'Monywa', slug: 'monywa' },
  { name: 'Prato', slug: 'prato' },
  { name: 'Probolinggo', slug: 'probolinggo' },
  { name: 'Sirsa', slug: 'sirsa' },
  { name: 'Guarenas', slug: 'guarenas' },
  { name: 'Anda', slug: 'anda' },
  { name: 'Saarbrücken', slug: 'saarbrucken' },
  { name: 'Shangqiu', slug: 'shangqiu' },
  { name: 'Wādī as Sīr', slug: 'wadi-as-sir' },
  { name: 'Groningen', slug: 'groningen' },
  { name: 'Taranto', slug: 'taranto' },
  { name: 'Malacca', slug: 'malacca' },
  { name: 'Chandannagar', slug: 'chandannagar' },
  { name: 'Gangneung', slug: 'gangneung' },
  { name: 'Baharampur', slug: 'baharampur' },
  { name: 'Dodoma', slug: 'dodoma' },
  { name: 'Crawley', slug: 'crawley' },
  { name: 'Rio Claro', slug: 'rio-claro' },
  { name: 'Tāngāil', slug: 'tangail' },
  { name: 'Matadi', slug: 'matadi' },
  { name: 'Castelló de la Plana', slug: 'castello-de-la-plana' },
  { name: 'Nepean', slug: 'nepean' },
  { name: 'Atyrau', slug: 'atyrau' },
  { name: 'Yasenevo', slug: 'yasenevo' },
  { name: 'Yangju', slug: 'yangju' },
  { name: 'Indaiatuba', slug: 'indaiatuba' },
  { name: 'Surendranagar', slug: 'surendranagar' },
  { name: 'Varāmīn', slug: 'varamin' },
  { name: 'Dosquebradas', slug: 'dosquebradas' },
  { name: 'Passo Fundo', slug: 'passo-fundo' },
  { name: 'Xianning', slug: 'xianning' },
  { name: 'Legaspi', slug: 'legaspi' },
  { name: 'Korla', slug: 'korla' },
  { name: 'Cotabato', slug: 'cotabato' },
  { name: 'Podolsk', slug: 'podolsk' },
  { name: 'Vizianagaram', slug: 'vizianagaram' },
  { name: 'Providence', slug: 'providence' },
  { name: 'Ila Orangun', slug: 'ila-orangun' },
  { name: 'Qianjiang', slug: 'qianjiang' },
  { name: 'Chenzhou', slug: 'chenzhou' },
  { name: 'Burgos', slug: 'burgos' },
  { name: 'Klerksdorp', slug: 'klerksdorp' },
  { name: 'Si Racha', slug: 'si-racha' },
  { name: 'Tiaret', slug: 'tiaret' },
  { name: 'Amadora', slug: 'amadora' },
  { name: 'Ipswich', slug: 'ipswich' },
  { name: 'Kamirenjaku', slug: 'kamirenjaku' },
  { name: 'Saki', slug: 'saki' },
  { name: 'Chlef', slug: 'chlef' },
  { name: 'Fort Lauderdale', slug: 'fort-lauderdale' },
  { name: 'East Flatbush', slug: 'east-flatbush' },
  { name: 'Anjō', slug: 'anjo' },
  { name: 'Spring Valley', slug: 'spring-valley' },
  { name: 'Kutaisi', slug: 'kutaisi' },
  { name: 'Ciudad Camilo Cienfuegos', slug: 'ciudad-camilo-cienfuegos' },
  { name: 'Jingzhou', slug: 'jingzhou' },
  { name: 'Proddatūr', slug: 'proddatur' },
  { name: 'Sittwe', slug: 'sittwe' },
  { name: 'Ar Raqqah', slug: 'ar-raqqah' },
  { name: 'Meiktila', slug: 'meiktila' },
  { name: 'Loum', slug: 'loum' },
  { name: 'Vellore', slug: 'vellore' },
  { name: 'Hugli', slug: 'hugli' },
  { name: 'Alappuzha', slug: 'alappuzha' },
  { name: 'Chattanooga', slug: 'chattanooga' },
  { name: 'Malāyer', slug: 'malayer' },
  { name: 'Bielsko-Biala', slug: 'bielsko-biala' },
  { name: 'Yuzhno-Sakhalinsk', slug: 'yuzhno-sakhalinsk' },
  { name: 'Almere Stad', slug: 'almere-stad' },
  { name: 'Split', slug: 'split' },
  { name: 'Saint-Étienne', slug: 'saint-etienne' },
  { name: 'Amroha', slug: 'amroha' },
  { name: 'Regina', slug: 'regina' },
  { name: 'Zhenzhou', slug: 'zhenzhou' },
  { name: 'Saint-Louis', slug: 'saint-louis' },
  { name: 'Turku', slug: 'turku' },
  { name: 'Tempe', slug: 'tempe' },
  { name: 'Xindi', slug: 'xindi' },
  { name: 'Oceanside', slug: 'oceanside' },
  { name: 'Bella Vista', slug: 'bella-vista' },
  { name: 'Tsukuba', slug: 'tsukuba' },
  { name: 'Sāveh', slug: 'saveh' },
  { name: 'Wigan', slug: 'wigan' },
  { name: 'Garden Grove', slug: 'garden-grove' },
  { name: 'Khowy', slug: 'khowy' },
  { name: 'Mzuzu', slug: 'mzuzu' },
  { name: 'Siverek', slug: 'siverek' },
  { name: 'Rancho Cucamonga', slug: 'rancho-cucamonga' },
  { name: 'Cape Coral', slug: 'cape-coral' },
  { name: 'Jiutai', slug: 'jiutai' },
  { name: 'Hirosaki', slug: 'hirosaki' },
  { name: 'Naga', slug: 'naga' },
  { name: 'Cotia', slug: 'cotia' },
  { name: 'Tomakomai', slug: 'tomakomai' },
  { name: 'Tambaram', slug: 'tambaram' },
  { name: 'Pamulang', slug: 'pamulang' },
  { name: 'Bo', slug: 'bo' },
  { name: 'Pathānkot', slug: 'pathankot' },
  { name: 'Hadano', slug: 'hadano' },
  { name: 'Bozhou', slug: 'bozhou' },
  { name: 'Cikupa', slug: 'cikupa' },
  { name: 'Bhind', slug: 'bhind' },
  { name: 'Puerto Cabello', slug: 'puerto-cabello' },
  { name: 'Obihiro', slug: 'obihiro' },
  { name: 'Ube', slug: 'ube' },
  { name: 'Kramators’k', slug: 'kramatorsk' },
  { name: 'Shimla', slug: 'shimla' },
  { name: 'Croydon', slug: 'croydon' },
  { name: 'Myeik', slug: 'myeik' },
  { name: 'East New York', slug: 'east-new-york' },
  { name: 'Khān Yūnis', slug: 'khan-yunis' },
  { name: 'Bata', slug: 'bata' },
  { name: 'Midrand', slug: 'midrand' },
  { name: 'Chicoloapan', slug: 'chicoloapan' },
  { name: 'Ongole', slug: 'ongole' },
  { name: 'Gadag-Betageri', slug: 'gadag-betageri' },
  { name: 'Licheng', slug: 'licheng' },
  { name: 'Salatiga', slug: 'salatiga' },
  { name: 'Miskolc', slug: 'miskolc' },
  { name: 'Isparta', slug: 'isparta' },
  { name: 'Weinan', slug: 'weinan' },
  { name: 'Kaolack', slug: 'kaolack' },
  { name: 'Walsall', slug: 'walsall' },
  { name: 'Herne', slug: 'herne' },
  { name: 'Lyublino', slug: 'lyublino' },
  { name: 'Mansfield', slug: 'mansfield' },
  { name: 'Olsztyn', slug: 'olsztyn' },
];

export const KEYWORD_LANDING_ROUTES = [
  {
    path: '/find-dinning-partner-near-me',
    title: 'Find Dinning Partner Near Me | Co-Eater',
    heading: 'Find Dinning Partner Near Me',
    description:
      'Use Co-Eater to find dining partners near you in India. Meet verified people for meals through a social dining platform built for travelers, professionals, and students.',
    keywords: [
      'Find dinning partner near me',
      'find dining partner near me',
      'social dining app India',
      'meal partner app',
    ],
  },
  {
    path: '/how-to-avoid-eating-alone-while-on-a-trip',
    title: 'How To Avoid Eating Alone While On A Trip | Co-Eater',
    heading: 'How To Avoid Eating Alone While On A Trip',
    description:
      'Learn practical ways to avoid eating alone while traveling. Discover social dining meetups, city-based meal partner matching, and non-dating ways to meet people over dinner.',
    keywords: [
      'how to avoid eating alone while on a trip',
      'travel dining companion',
      'find people to eat with while traveling',
      'social dining while traveling',
    ],
  },
  {
    path: '/non-dating-apps-to-meet-people-on-dinner',
    title: 'Non Dating Apps To Meet People On Dinner | Co-Eater',
    heading: 'Non Dating Apps To Meet People On Dinner',
    description:
      'Co-Eater is a non-dating social dining app where you can meet people for lunch or dinner in your city. Build real food connections without dating pressure.',
    keywords: [
      'non dating apps to meet people on dinner',
      'non dating apps to meet people',
      'social dining category app',
      'make friends over dinner',
    ],
  },
]

export const CORE_STATIC_ROUTES = [
  '/',
  '/about',
  '/privacy-policy',
  '/terms-of-use',
  '/blogs',
  '/delete-account',
]

export function getCityBySlug(citySlug) {
  return MAJOR_INDIAN_CITIES.find((city) => city.slug === citySlug)
}

export function getCityLandingPath(citySlug) {
  return `/${citySlug}/find-dining-partner`
}

async function getBlogSeoPaths() {
  try {
    const response = await fetch(`${BLOGS_API_BASE}/blogs?limit=500`)
    if (!response.ok) throw new Error(`HTTP ${response.status}`)

    const blogs = await response.json()
    if (!Array.isArray(blogs)) return []

    return blogs
      .map((blog) => String(blog?.slug || '').trim())
      .filter(Boolean)
      .map((slug) => `/blogs/${slug}`)
  } catch (error) {
    console.error('Failed to fetch blog paths for sitemap SEO:', error)
    return []
  }
}

async function fetchJson(path) {
  const response = await fetch(`${BLOGS_API_BASE}${path}`)
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`)
  }
  return response.json()
}

async function getRestaurantSeoPaths() {
  try {
    const restaurants = await fetchJson('/restaurants?city=all')
    if (!Array.isArray(restaurants)) return []

    return restaurants
      .map((restaurant) => {
        const cityName = String(restaurant?.city || '').trim()
        const restaurantName = String(restaurant?.name || '').trim()
        if (!cityName || !restaurantName) return null
        return getRestaurantSeoPath(cityName, restaurantName)
      })
      .filter(Boolean)
  } catch (error) {
    console.error('Failed to fetch restaurant paths for sitemap SEO:', error)
    return []
  }
}

async function getProfileSeoPaths() {
  try {
    const seen = new Set()
    const paths = []
    let page = 0

    while (page < 100) {
      const payload = await fetchJson(`/users?limit=50&page=${page}`)
      const users = Array.isArray(payload?.users) ? payload.users : []

      for (const user of users) {
        const name = String(user?.name || '').trim()
        if (!name) continue
        const path = getProfileSeoPath(name)
        if (seen.has(path)) continue
        seen.add(path)
        paths.push(path)
      }

      if (!payload?.hasMore || users.length === 0) break
      page += 1
    }

    return paths
  } catch (error) {
    console.error('Failed to fetch profile paths for sitemap SEO:', error)
    return []
  }
}

async function getEventSeoPaths() {
  try {
    const payload = await fetchJson('/group?limit=500')
    const events = Array.isArray(payload?.events) ? payload.events : []

    return events
      .map((event) => {
        const cityName = String(event?.city || '').trim()
        const tableName = String(event?.tableName || '').trim()
        if (!cityName || !tableName) return null
        return getEventSeoPath(cityName, tableName)
      })
      .filter(Boolean)
  } catch (error) {
    console.error('Failed to fetch event paths for sitemap SEO:', error)
    return []
  }
}

export async function getAllSeoPaths() {
  const cityPaths = MAJOR_INDIAN_CITIES.map((city) => getCityLandingPath(city.slug))
  const restaurantCityPaths = MAJOR_INDIAN_CITIES.map((city) => getRestaurantCitySeoPath(city.name))
  const eventCityPaths = MAJOR_INDIAN_CITIES.map((city) => getEventCitySeoPath(city.name))
  const keywordPaths = KEYWORD_LANDING_ROUTES.map((entry) => entry.path)
  const blogPaths = await getBlogSeoPaths()
  const restaurantPaths = await getRestaurantSeoPaths()
  const profilePaths = await getProfileSeoPaths()
  const eventPaths = await getEventSeoPaths()

  return [...new Set([...CORE_STATIC_ROUTES, ...keywordPaths, ...cityPaths, ...restaurantCityPaths, ...eventCityPaths, ...blogPaths, ...restaurantPaths, ...profilePaths, ...eventPaths])]
}
